export const epg = [
    {
        id: '6f3caa7f-5b11-4edb-998e-80d4baa03373',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        isYesterday: true,
        since: '2022-10-17T23:50:00',
        till: '2022-10-18T00:55:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Ghana',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 3,
        locked: true,
    },
    {
        id: 'f8fa7e21-6a8a-4ccc-8859-6f61a31f2f55',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T00:55:00',
        till: '2022-10-18T02:35:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Mozambique',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 1,
    },
    {
        id: 'a3945c66-4192-44a2-ac30-65e9ddfd9afe',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T02:35:00',
        till: '2022-10-18T03:30:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Yemen',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 3,
    },
    {
        id: '45b01668-f72b-4efe-8667-8f5bf130847d',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T03:30:00',
        till: '2022-10-18T04:15:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Belarus',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 3,
    },
    {
        id: 'c17eb7ea-926a-4b9a-8e4f-1aadb0ad0caf',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T04:15:00',
        till: '2022-10-18T04:30:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Israel',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 2,
    },
    {
        id: '63f4ce0d-e6ec-46c7-83f0-f9182ff2ba2f',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T04:30:00',
        till: '2022-10-18T05:10:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Congo - Kinshasa',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: 'e4d706ff-2443-4fd3-82da-34f37114dffd',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T05:10:00',
        till: '2022-10-18T05:35:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Samoa',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 5,
    },
    {
        id: '47f587a5-cd3b-49e1-b284-472e1a4e053e',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T05:35:00',
        till: '2022-10-18T06:00:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Guam',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 2,
    },
    {
        id: '4acba6ec-ec73-4d7c-9804-9a177f433e3e',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T06:00:00',
        till: '2022-10-18T07:00:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Unknown or Invalid Region',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 4,
    },
    {
        id: 'de1a9d1a-4729-418d-8fd0-9ca230759626',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T07:00:00',
        till: '2022-10-18T07:40:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Papua New Guinea',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 4,
    },
    {
        id: '7d351a9f-c293-40fd-ac0b-75886490ac9f',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T07:40:00',
        till: '2022-10-18T08:05:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Botswana',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 2,
    },
    {
        id: 'e1403291-d5ec-48b6-877a-0ca1d3cd5825',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T08:05:00',
        till: '2022-10-18T08:20:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Liberia',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 2,
    },
    {
        id: 'c2eb0043-cc62-4acc-a32a-755e12df8935',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T08:20:00',
        till: '2022-10-18T08:45:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Union of Soviet Socialist Republics',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 3,
    },
    {
        id: 'c4c28f90-a108-45f8-af07-4f6cdbd29ba2',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T08:45:00',
        till: '2022-10-18T09:15:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'El Salvador',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 4,
    },
    {
        id: '400388af-ddf8-4582-918d-c769c6511cb1',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T09:15:00',
        till: '2022-10-18T10:20:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'U.S. Minor Outlying Islands',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 5,
    },
    {
        id: '3a3c5f44-4ebc-4391-8709-e2a6429e4815',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T10:20:00',
        till: '2022-10-18T11:15:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Timor-Leste',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 5,
    },
    {
        id: '9d5e8b81-ae6a-47a6-bf32-26e66455850a',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T11:15:00',
        till: '2022-10-18T11:50:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Namibia',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 2,
    },
    {
        id: '7721cad1-ab1e-43bb-9e29-69eae38f359b',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T11:50:00',
        till: '2022-10-18T13:45:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Uruguay',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 3,
    },
    {
        id: 'a3a16fe6-b41b-4544-9b2c-c9403c1d8821',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T13:45:00',
        till: '2022-10-18T13:55:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Bangladesh',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 3,
    },
    {
        id: 'cb7ee80d-c356-42d7-b799-8df8b83e88f7',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T13:55:00',
        till: '2022-10-18T14:55:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Union of Soviet Socialist Republics',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 5,
    },
    {
        id: 'a6bad192-efa9-4c60-bb9c-977a541d77d1',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T14:55:00',
        till: '2022-10-18T15:55:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Qatar',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: '9f0cb123-98ec-4015-92b9-681eef258da3',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T15:55:00',
        till: '2022-10-18T17:00:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Heard Island and McDonald Islands',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 5,
        locked: true,
    },
    {
        id: '1b124812-06c8-4780-9d10-cb830bf20499',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T17:00:00',
        till: '2022-10-18T17:20:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Åland Islands',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 4,
    },
    {
        id: 'dba1e43f-1260-45d9-bb74-2a790f3fc10a',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T17:20:00',
        till: '2022-10-18T17:30:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Lithuania',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 4,
    },
    {
        id: '772d150c-de2f-463a-9491-eb96cdeb2012',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T17:30:00',
        till: '2022-10-18T18:30:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Isle of Man',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 1,
    },
    {
        id: '3c417377-1904-444f-a1b0-1a229ec0bb1f',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T18:30:00',
        till: '2022-10-18T19:25:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Portugal',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 5,
    },
    {
        id: '962874dd-9954-4e8f-a636-54077a2f16b1',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T19:25:00',
        till: '2022-10-18T19:30:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Sierra Leone',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 3,
    },
    {
        id: 'a5d3f5e7-5a1e-440d-b450-3041625b0402',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T19:30:00',
        till: '2022-10-18T20:05:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Brunei',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 4,
    },
    {
        id: 'cc7dec2c-4376-4f84-bb57-829abbcda987',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T20:05:00',
        till: '2022-10-18T20:10:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Tanzania',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 3,
    },
    {
        id: '3e98cb75-8510-465d-9266-616ce8d94d97',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T20:10:00',
        till: '2022-10-18T20:35:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Iran',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 4,
    },
    {
        id: '9624e194-1a21-47f6-aee4-81cd19ae2100',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T20:35:00',
        till: '2022-10-18T21:35:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Anguilla',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 5,
    },
    {
        id: '81360905-6777-4c1c-88a6-cba89edc02d7',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T21:35:00',
        till: '2022-10-18T23:30:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Costa Rica',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 1,
        locked: true,
    },
    {
        id: 'f415090d-198d-45d9-8d60-641e75c41e0b',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T23:30:00',
        isTomorrow: true,
        till: '2022-10-19T01:25:00',
        channelUuid: '16fdfefe-e466-4090-bc1a-57c43937f826',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Tuvalu',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 3,
    },
    {
        id: '4283023a-8bc8-453b-ba29-2af931c37e4d',
        description:
            "A hedonistic jingle writer's free-wheeling life comes to an abrupt halt when his brother and 10-year-old nephew move into his beach-front house.",
        title: 'Two and a Half Men',
        isYesterday: true,
        since: '2022-10-17T23:10:00',
        till: '2022-10-18T01:35:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/lW3r6Fb7dwZ0bpGwjYHMVkgSVRt.jpg',
        country: 'Colombia',
        Year: '2003–2015',
        Rated: 'TV-14',
        Released: '22 Sep 2003',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Lee Aronsohn, Chuck Lorre',
        Actors: 'Jon Cryer, Ashton Kutcher, Angus T. Jones',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 9 Primetime Emmys. 30 wins & 72 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.0',
        imdbVotes: '253,658',
        imdbID: 'tt0369179',
        Type: 'series',
        totalSeasons: '12',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.0/10' }],
        rating: 5,
    },
    {
        id: '7d7deff1-5c78-41ab-89d5-58dd286db55a',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T01:35:00',
        till: '2022-10-18T03:45:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Brazil',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 2,
    },
    {
        id: '15d6a4d6-9a8b-4001-8232-3ffa5b0fcf14',
        description:
            'During a perilous 24-hour mission on the moon, space explorers try to retrieve samples from an abandoned research facility steeped in classified secrets.',
        title: 'The Silent Sea',
        since: '2022-10-18T03:45:00',
        till: '2022-10-18T05:15:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/9hNJ3fvIVd4WE3rU1Us2awoTpgM.jpg',
        country: 'Isle of Man',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '24 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Adventure, Drama, Mystery',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Bae Doona, Gong Yoo, Joon Lee',
        Language: 'Korean',
        Country: 'South Korea',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '6.9',
        imdbVotes: '13,008',
        imdbID: 'tt11570202',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.9/10' }],
        rating: 2,
    },
    {
        id: 'a9b65ac7-04d1-479e-ae99-cb06e84a92d5',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T05:15:00',
        till: '2022-10-18T05:20:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Spain',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 3,
    },
    {
        id: '3852ccee-87e9-4dd0-a18d-a88d4159feba',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T05:20:00',
        till: '2022-10-18T05:50:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Estonia',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 1,
    },
    {
        id: '6912cf8b-cbca-4599-95b9-ec27a1d30083',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T05:50:00',
        till: '2022-10-18T06:25:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Israel',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 3,
    },
    {
        id: '2754d7a2-fc50-4c36-9b61-88619abbc62f',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T06:25:00',
        till: '2022-10-18T07:00:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Moldova',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 4,
    },
    {
        id: 'ec023926-3240-41f1-a977-471c7d4a0aa6',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T07:00:00',
        till: '2022-10-18T07:55:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Zambia',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 1,
    },
    {
        id: '1a53da65-9910-4eaa-a4a1-b845f574efa5',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T07:55:00',
        till: '2022-10-18T11:50:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Niue',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 5,
    },
    {
        id: '64be0965-c039-4e7c-b624-d1101454ebca',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T11:50:00',
        till: '2022-10-18T12:30:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Guinea',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 3,
    },
    {
        id: '9a6d9fcc-eb3c-43e0-b86d-0c2aebde457d',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T12:30:00',
        till: '2022-10-18T14:00:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'U.S. Minor Outlying Islands',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 4,
    },
    {
        id: 'a908f867-e101-4522-9795-65d9e81ff90e',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T14:00:00',
        till: '2022-10-18T14:35:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'British Antarctic Territory',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 5,
    },
    {
        id: '0f0db2a5-a55e-4bbb-860e-f25a433db3f8',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T14:35:00',
        till: '2022-10-18T15:15:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Saint Kitts and Nevis',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 2,
    },
    {
        id: '17979ac5-53f8-46dc-ac1a-99bdcdaa69f6',
        description:
            "A hedonistic jingle writer's free-wheeling life comes to an abrupt halt when his brother and 10-year-old nephew move into his beach-front house.",
        title: 'Two and a Half Men',
        since: '2022-10-18T15:15:00',
        till: '2022-10-18T16:15:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/lW3r6Fb7dwZ0bpGwjYHMVkgSVRt.jpg',
        country: 'Costa Rica',
        Year: '2003–2015',
        Rated: 'TV-14',
        Released: '22 Sep 2003',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Lee Aronsohn, Chuck Lorre',
        Actors: 'Jon Cryer, Ashton Kutcher, Angus T. Jones',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 9 Primetime Emmys. 30 wins & 72 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.0',
        imdbVotes: '253,658',
        imdbID: 'tt0369179',
        Type: 'series',
        totalSeasons: '12',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.0/10' }],
        rating: 5,
    },
    {
        id: '56964cd3-6f42-4436-bb31-b3c88e5849ae',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T16:15:00',
        till: '2022-10-18T17:15:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Malaysia',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 2,
    },
    {
        id: '516d088a-018a-4aca-b355-d4fbe13398ba',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T17:15:00',
        till: '2022-10-18T17:50:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Azerbaijan',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 4,
    },
    {
        id: '0c48452e-45dc-4fef-a81c-3ba133ed0caa',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T17:50:00',
        till: '2022-10-18T18:00:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Taiwan',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 4,
    },
    {
        id: '06b2f06b-d60c-47e5-b249-a8854fdff2f5',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T18:00:00',
        till: '2022-10-18T18:20:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Neutral Zone',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 5,
    },
    {
        id: '5746f038-7625-4ea3-bab0-b3c90dfe804e',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T18:20:00',
        till: '2022-10-18T18:30:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Uganda',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 4,
    },
    {
        id: '12cfe5cc-28da-466e-83c7-adfa620990cb',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T18:30:00',
        till: '2022-10-18T19:20:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Lithuania',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 4,
    },
    {
        id: 'd131c778-032e-4d6a-a866-2829617d56db',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T19:20:00',
        till: '2022-10-18T20:00:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'China',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 5,
    },
    {
        id: '5f9e54fe-c761-4846-bb48-43278823f219',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T20:00:00',
        till: '2022-10-18T21:05:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'American Samoa',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 1,
    },
    {
        id: 'a55c9e78-18a5-448e-91ba-954627f803d5',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T21:05:00',
        till: '2022-10-18T22:00:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Colombia',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 3,
    },
    {
        id: '87a66541-b7f7-413c-b84b-f52fb5eede5f',
        description:
            'During a perilous 24-hour mission on the moon, space explorers try to retrieve samples from an abandoned research facility steeped in classified secrets.',
        title: 'The Silent Sea',
        since: '2022-10-18T22:00:00',
        till: '2022-10-18T23:05:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/9hNJ3fvIVd4WE3rU1Us2awoTpgM.jpg',
        country: 'Aruba',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '24 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Adventure, Drama, Mystery',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Bae Doona, Gong Yoo, Joon Lee',
        Language: 'Korean',
        Country: 'South Korea',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '6.9',
        imdbVotes: '13,008',
        imdbID: 'tt11570202',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.9/10' }],
        rating: 3,
    },
    {
        id: 'b5c98681-10f7-420e-bba6-9f25f85ff6a0',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T23:05:00',
        isTomorrow: true,
        till: '2022-10-19T00:15:00',
        channelUuid: '96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Liechtenstein',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 2,
    },
    {
        id: 'e3441fd3-688b-42fa-975e-3a7d84a8253c',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        isYesterday: true,
        since: '2022-10-17T22:20:00',
        till: '2022-10-18T00:25:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'Jamaica',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 4,
    },
    {
        id: 'ff4df118-25e7-4c98-9272-81b198436fd9',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T00:25:00',
        till: '2022-10-18T01:30:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Pitcairn Islands',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 4,
    },
    {
        id: '9f5010f9-2464-46c5-a4bf-2abd77d5f736',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T01:30:00',
        till: '2022-10-18T02:50:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Marshall Islands',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 2,
    },
    {
        id: 'e9484b9e-2389-4264-989f-d71578022b23',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T02:50:00',
        till: '2022-10-18T04:05:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Midway Islands',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 1,
    },
    {
        id: '7c272c02-5003-4999-a847-6eca092e006b',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T04:05:00',
        till: '2022-10-18T04:30:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'British Indian Ocean Territory',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 4,
    },
    {
        id: '12b08d75-fee5-4cc9-954e-229bf7337fd2',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T04:30:00',
        till: '2022-10-18T05:15:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'Qatar',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 3,
    },
    {
        id: 'd93fa4eb-0e84-4488-a032-a75c8d066d11',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T05:15:00',
        till: '2022-10-18T05:30:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Cocos [Keeling] Islands',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 2,
    },
    {
        id: '51ac5755-0517-4aab-a2a4-675af44e7d9c',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T05:30:00',
        till: '2022-10-18T06:30:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Estonia',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 3,
    },
    {
        id: '12d43b9a-42f4-4d65-abf3-dbec3f08cd87',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T06:30:00',
        till: '2022-10-18T07:30:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Congo - Kinshasa',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 3,
    },
    {
        id: '7574df60-b9a2-4000-abc9-5b91eb222401',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T07:30:00',
        till: '2022-10-18T08:00:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Paraguay',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 4,
    },
    {
        id: '4ea54d71-2943-4faf-8ba7-dfa03f1a5e25',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T08:00:00',
        till: '2022-10-18T11:30:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Sudan',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 4,
    },
    {
        id: '38896f93-013b-430e-9119-d3885c186bea',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T11:30:00',
        till: '2022-10-18T11:55:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Svalbard and Jan Mayen',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 5,
    },
    {
        id: '4c73689f-eb92-4803-824e-f03fec5da4fa',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T11:55:00',
        till: '2022-10-18T12:20:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Palau',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 1,
    },
    {
        id: '5a21df2d-fd29-4dcf-8f91-6c0e6b635079',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T12:20:00',
        till: '2022-10-18T13:00:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Liechtenstein',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 4,
    },
    {
        id: 'f1a24542-d443-48d6-b010-8858385fde46',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T13:00:00',
        till: '2022-10-18T14:05:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Cayman Islands',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 3,
    },
    {
        id: '7463d11e-273b-4606-81d4-33bb9fac390a',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T14:05:00',
        till: '2022-10-18T14:40:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Poland',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 2,
    },
    {
        id: '025c3ecc-3bf6-428e-a2f1-5ac5fd8c7bf5',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T14:40:00',
        till: '2022-10-18T15:10:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Equatorial Guinea',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 1,
    },
    {
        id: 'da51757c-15a8-47d2-b1dc-9a0f6a16e6c6',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T15:10:00',
        till: '2022-10-18T15:45:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Eritrea',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 2,
    },
    {
        id: '00005cc3-783e-46fc-ba02-31f943f519f5',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T15:45:00',
        till: '2022-10-18T16:15:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Mozambique',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 4,
    },
    {
        id: '9b0a890f-3377-4d5e-8c68-64ae74018a8e',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T16:15:00',
        till: '2022-10-18T17:25:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Belarus',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 2,
    },
    {
        id: '03fab633-77a8-4a94-b69f-bfcc4c6012fc',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        since: '2022-10-18T17:25:00',
        till: '2022-10-18T17:35:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'Lithuania',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 1,
    },
    {
        id: '0dfadd83-0d29-4b66-9584-d1dbb591b76d',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T17:35:00',
        till: '2022-10-18T18:05:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'French Polynesia',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 2,
    },
    {
        id: 'f1da6552-5e40-4e5c-a91a-4fae5e2e3529',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T18:05:00',
        till: '2022-10-18T18:30:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Cambodia',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 2,
    },
    {
        id: 'e80a0f80-0cd5-4969-9a25-172d2c886e1c',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T18:30:00',
        till: '2022-10-18T19:00:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Faroe Islands',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 4,
    },
    {
        id: '92836eca-342f-40c6-badf-b7dcfa94566e',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T19:00:00',
        till: '2022-10-18T19:25:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Dominica',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 3,
    },
    {
        id: '573c7432-4bc9-4349-b40a-94c39f4671fe',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T19:25:00',
        till: '2022-10-18T19:30:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Isle of Man',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 5,
    },
    {
        id: '2cf14c4d-f655-4625-aac4-d2e7b29cd42a',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T19:30:00',
        till: '2022-10-18T19:40:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Malawi',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 5,
    },
    {
        id: 'a4cb6ffc-16cc-46f6-81ab-66515dcda452',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        since: '2022-10-18T19:40:00',
        till: '2022-10-18T19:50:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'Laos',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 4,
    },
    {
        id: '4fb8cdae-a874-406e-9dbb-2edc5af70b60',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T19:50:00',
        till: '2022-10-18T20:05:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Cameroon',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 3,
    },
    {
        id: '54421f17-67ee-499a-9152-017686a02ec6',
        description:
            "A hedonistic jingle writer's free-wheeling life comes to an abrupt halt when his brother and 10-year-old nephew move into his beach-front house.",
        title: 'Two and a Half Men',
        since: '2022-10-18T20:05:00',
        till: '2022-10-18T22:55:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/lW3r6Fb7dwZ0bpGwjYHMVkgSVRt.jpg',
        country: 'Maldives',
        Year: '2003–2015',
        Rated: 'TV-14',
        Released: '22 Sep 2003',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Lee Aronsohn, Chuck Lorre',
        Actors: 'Jon Cryer, Ashton Kutcher, Angus T. Jones',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 9 Primetime Emmys. 30 wins & 72 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.0',
        imdbVotes: '253,658',
        imdbID: 'tt0369179',
        Type: 'series',
        totalSeasons: '12',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.0/10' }],
        rating: 4,
    },
    {
        id: 'f5f58506-2d87-43b5-8cb6-960fa6a60826',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T22:55:00',
        isTomorrow: true,
        till: '2022-10-19T00:50:00',
        channelUuid: '06d3366b-9ec2-46e8-a741-df3ee1abeed7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Hungary',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 4,
    },
    {
        id: 'c6f9ddf6-aa54-418d-ac6e-d4eef30b3f7c',
        description:
            'During a perilous 24-hour mission on the moon, space explorers try to retrieve samples from an abandoned research facility steeped in classified secrets.',
        title: 'The Silent Sea',
        isYesterday: true,
        since: '2022-10-17T23:15:00',
        till: '2022-10-18T01:00:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/9hNJ3fvIVd4WE3rU1Us2awoTpgM.jpg',
        country: 'Belize',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '24 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Adventure, Drama, Mystery',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Bae Doona, Gong Yoo, Joon Lee',
        Language: 'Korean',
        Country: 'South Korea',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '6.9',
        imdbVotes: '13,008',
        imdbID: 'tt11570202',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.9/10' }],
        rating: 4,
    },
    {
        id: '3d31dcb8-f199-4902-974e-28001124bc52',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T01:00:00',
        till: '2022-10-18T02:05:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Gibraltar',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 1,
        locked: true,
    },
    {
        id: '76064cd7-a3c0-46e2-b30a-766b8ac50022',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T02:05:00',
        till: '2022-10-18T02:45:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'Ireland',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 2,
    },
    {
        id: '0dc7d29d-b821-4b0b-8ed2-1990831bdf30',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T02:45:00',
        till: '2022-10-18T05:05:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Austria',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 3,
    },
    {
        id: '2f482b43-0be2-437a-855c-293d05c8c69a',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        since: '2022-10-18T05:05:00',
        till: '2022-10-18T06:05:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'Macedonia',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 3,
    },
    {
        id: '5b6df978-b602-4ed3-9835-f2f8ac1cc899',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T06:05:00',
        till: '2022-10-18T07:00:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Fiji',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 5,
    },
    {
        id: '52439ebe-45f1-45c3-979e-d21bde0b2684',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T07:00:00',
        till: '2022-10-18T07:15:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Tonga',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 4,
    },
    {
        id: '6d5c3507-bbbe-499e-9242-6eb230776626',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T07:15:00',
        till: '2022-10-18T07:50:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Timor-Leste',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 5,
    },
    {
        id: 'dc78b175-db7c-4a96-850e-e5806720ed11',
        description:
            'During a perilous 24-hour mission on the moon, space explorers try to retrieve samples from an abandoned research facility steeped in classified secrets.',
        title: 'The Silent Sea',
        since: '2022-10-18T07:50:00',
        till: '2022-10-18T09:40:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/9hNJ3fvIVd4WE3rU1Us2awoTpgM.jpg',
        country: 'Turks and Caicos Islands',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '24 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Adventure, Drama, Mystery',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Bae Doona, Gong Yoo, Joon Lee',
        Language: 'Korean',
        Country: 'South Korea',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '6.9',
        imdbVotes: '13,008',
        imdbID: 'tt11570202',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.9/10' }],
        rating: 2,
    },
    {
        id: '6ecf302e-0334-4d1f-970b-0d7c5354d395',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T09:40:00',
        till: '2022-10-18T10:40:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Syria',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 3,
    },
    {
        id: '8ed8e62a-8d7b-4ca0-80da-8c87478d7904',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T10:40:00',
        till: '2022-10-18T11:45:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Saint Vincent and the Grenadines',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 3,
    },
    {
        id: '26daa372-f74b-4ddb-80b0-4eb99f1e0dc8',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T11:45:00',
        till: '2022-10-18T12:45:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Isle of Man',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 5,
    },
    {
        id: 'b107c5f1-e517-4648-b747-0736fcdda295',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T12:45:00',
        till: '2022-10-18T13:50:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Singapore',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 3,
    },
    {
        id: '0605fd9c-5c62-4634-92e7-534a2c09baa9',
        description:
            "A hedonistic jingle writer's free-wheeling life comes to an abrupt halt when his brother and 10-year-old nephew move into his beach-front house.",
        title: 'Two and a Half Men',
        since: '2022-10-18T13:50:00',
        till: '2022-10-18T15:55:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/lW3r6Fb7dwZ0bpGwjYHMVkgSVRt.jpg',
        country: 'Honduras',
        Year: '2003–2015',
        Rated: 'TV-14',
        Released: '22 Sep 2003',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Lee Aronsohn, Chuck Lorre',
        Actors: 'Jon Cryer, Ashton Kutcher, Angus T. Jones',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 9 Primetime Emmys. 30 wins & 72 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.0',
        imdbVotes: '253,658',
        imdbID: 'tt0369179',
        Type: 'series',
        totalSeasons: '12',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.0/10' }],
        rating: 4,
    },
    {
        id: 'f78d43a3-bc9e-451f-84f5-49988883c6bc',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T15:55:00',
        till: '2022-10-18T18:05:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Fiji',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 1,
    },
    {
        id: 'f0cf0267-65d3-4e64-b677-d7639908b272',
        description:
            "A hedonistic jingle writer's free-wheeling life comes to an abrupt halt when his brother and 10-year-old nephew move into his beach-front house.",
        title: 'Two and a Half Men',
        since: '2022-10-18T18:05:00',
        till: '2022-10-18T20:00:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/lW3r6Fb7dwZ0bpGwjYHMVkgSVRt.jpg',
        country: 'Slovakia',
        Year: '2003–2015',
        Rated: 'TV-14',
        Released: '22 Sep 2003',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Lee Aronsohn, Chuck Lorre',
        Actors: 'Jon Cryer, Ashton Kutcher, Angus T. Jones',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 9 Primetime Emmys. 30 wins & 72 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.0',
        imdbVotes: '253,658',
        imdbID: 'tt0369179',
        Type: 'series',
        totalSeasons: '12',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.0/10' }],
        rating: 1,
    },
    {
        id: '4dc7f5f1-cc60-4e86-9f0f-d3abc0d32a52',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        since: '2022-10-18T20:00:00',
        till: '2022-10-18T22:50:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'Saint Helena',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 1,
    },
    {
        id: '43f00840-802f-4642-8ba4-56b58a084187',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T22:50:00',
        isTomorrow: true,
        till: '2022-10-19T01:10:00',
        channelUuid: 'b51689be-8eb4-4481-b208-6bbcb7fb47c2',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Faroe Islands',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 1,
    },
    {
        id: '079d6658-40a7-42ae-97b8-d69ceb3efe85',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        isYesterday: true,
        since: '2022-10-17T23:10:00',
        till: '2022-10-18T02:15:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Armenia',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 2,
    },
    {
        id: '306186a3-36d4-4fd3-a925-9044409e3ea6',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T02:15:00',
        till: '2022-10-18T04:40:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'North Vietnam',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 2,
    },
    {
        id: 'f75fec0c-889d-4875-bce6-b01bde9c6287',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        since: '2022-10-18T04:40:00',
        till: '2022-10-18T05:25:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'Egypt',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 1,
    },
    {
        id: 'e3d1e5a7-8023-44ba-9366-6fc37973752c',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T05:25:00',
        till: '2022-10-18T06:00:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Chad',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 1,
    },
    {
        id: 'eba650e8-9a20-4294-b2d1-ee7cc88de701',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T06:00:00',
        till: '2022-10-18T08:25:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Mozambique',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 5,
    },
    {
        id: '10a64a5e-35a4-45cd-a6fd-d9f08556b00c',
        description:
            'During a perilous 24-hour mission on the moon, space explorers try to retrieve samples from an abandoned research facility steeped in classified secrets.',
        title: 'The Silent Sea',
        since: '2022-10-18T08:25:00',
        till: '2022-10-18T10:10:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/9hNJ3fvIVd4WE3rU1Us2awoTpgM.jpg',
        country: 'Niue',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '24 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Adventure, Drama, Mystery',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Bae Doona, Gong Yoo, Joon Lee',
        Language: 'Korean',
        Country: 'South Korea',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '6.9',
        imdbVotes: '13,008',
        imdbID: 'tt11570202',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.9/10' }],
        rating: 5,
    },
    {
        id: '337c0067-242c-47ff-8e94-de02f071b9ae',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T10:10:00',
        till: '2022-10-18T10:40:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Bhutan',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 5,
    },
    {
        id: '434200ae-2903-4694-ad75-f95b9d9c8b74',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T10:40:00',
        till: '2022-10-18T11:40:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Bahamas',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 5,
    },
    {
        id: '4874715a-0e85-4094-9fab-b3d771212e77',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T11:40:00',
        till: '2022-10-18T12:40:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Finland',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 3,
    },
    {
        id: '3ea8eab5-8467-4642-8fb6-d301ef1a7fe2',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T12:40:00',
        till: '2022-10-18T13:45:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Bangladesh',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 1,
    },
    {
        id: '4d2c880b-f1a9-4592-9904-a4dc118d88be',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T13:45:00',
        till: '2022-10-18T14:15:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Japan',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 3,
    },
    {
        id: 'b63a3a29-4bb2-4160-bddb-4111e1182877',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T14:15:00',
        till: '2022-10-18T14:40:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Denmark',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 2,
    },
    {
        id: '0f3857fa-8cbd-46ce-b7f8-38a3761c51d4',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T14:40:00',
        till: '2022-10-18T15:45:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Turkey',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 1,
    },
    {
        id: 'f076d095-0c89-4cc3-85ee-c806e55d22b9',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T15:45:00',
        till: '2022-10-18T16:15:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Kenya',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 3,
    },
    {
        id: '7138a65c-55c8-4b00-8fc5-d0583b1bd8e9',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        since: '2022-10-18T16:15:00',
        till: '2022-10-18T16:45:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'Comoros',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 3,
    },
    {
        id: '81ccc7d0-0eb7-48ef-acd6-8ff9fed42379',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        since: '2022-10-18T16:45:00',
        till: '2022-10-18T17:15:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'Cocos [Keeling] Islands',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 1,
    },
    {
        id: 'cf188555-3f7e-4cf1-8664-877e2b06a0dc',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T17:15:00',
        till: '2022-10-18T17:45:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Uruguay',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 3,
    },
    {
        id: 'c96f87a8-6391-4a9d-a816-237345388ffa',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T17:45:00',
        till: '2022-10-18T18:15:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'San Marino',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 5,
    },
    {
        id: 'b9d55c4b-2467-4384-bc93-a4db07a5ca66',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T18:15:00',
        till: '2022-10-18T18:50:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Luxembourg',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 3,
    },
    {
        id: '66481aa4-d26e-4cd2-8e85-327de0c7c08e',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T18:50:00',
        till: '2022-10-18T19:25:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'American Samoa',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 3,
    },
    {
        id: '09484ae5-5855-4b72-b9a4-042bc5e20310',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T19:25:00',
        till: '2022-10-18T19:45:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Croatia',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 5,
    },
    {
        id: '41587f44-001a-4901-9be5-02947f0fc333',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T19:45:00',
        till: '2022-10-18T19:55:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Ireland',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: '8ea80f99-4703-46e6-a777-3e9ba68d1fa3',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T19:55:00',
        till: '2022-10-18T20:00:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Sri Lanka',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 2,
    },
    {
        id: '34c2b79a-b0b1-4ce4-bbbf-36785fd7de88',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T20:00:00',
        till: '2022-10-18T22:00:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Tuvalu',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 3,
    },
    {
        id: '8551733b-fdda-401b-a337-fae168f5b0a2',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T22:00:00',
        isTomorrow: true,
        till: '2022-10-19T00:45:00',
        channelUuid: 'b95dc0e8-93d6-473e-a0ce-839d988b1dcf',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Svalbard and Jan Mayen',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 4,
    },
    {
        id: 'd5d67ed1-2174-4b25-ace8-d609b1ecca92',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        isYesterday: true,
        since: '2022-10-17T23:25:00',
        till: '2022-10-18T00:25:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Moldova',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 3,
    },
    {
        id: 'bdbc397f-22da-40c3-903c-ea4262e4f05e',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T00:25:00',
        till: '2022-10-18T01:25:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Sierra Leone',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 4,
    },
    {
        id: 'e9a46c95-7a5e-45a5-ac06-020a879f1b25',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T01:25:00',
        till: '2022-10-18T02:20:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Cambodia',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 2,
    },
    {
        id: 'fcd668ac-5b33-41a7-a0ae-1d717a2bc5bb',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T02:20:00',
        till: '2022-10-18T03:20:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Mongolia',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 1,
    },
    {
        id: '7e1bd398-649b-4de3-b86f-be0813b6b8f8',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T03:20:00',
        till: '2022-10-18T05:05:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Hong Kong SAR China',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 1,
    },
    {
        id: 'c0fd229c-eea8-4c56-93b9-18b6800523dd',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T05:05:00',
        till: '2022-10-18T05:15:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Kiribati',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 3,
    },
    {
        id: '5bcc894f-ad22-4c09-b202-a8096519ebd8',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T05:15:00',
        till: '2022-10-18T05:50:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Burundi',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 1,
    },
    {
        id: 'da081666-0686-4bd3-b61e-861aab134f8b',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T05:50:00',
        till: '2022-10-18T06:20:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Albania',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 3,
    },
    {
        id: 'a8089468-2aaa-4cc1-80ed-3dc5ed230b1d',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        since: '2022-10-18T06:20:00',
        till: '2022-10-18T06:55:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'Mauritius',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 4,
    },
    {
        id: '66761833-0262-454d-bca0-e083ef7dbe60',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T06:55:00',
        till: '2022-10-18T07:30:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Bouvet Island',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 1,
    },
    {
        id: '9f54803c-720b-412f-922f-38dfff349f36',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T07:30:00',
        till: '2022-10-18T08:05:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Nauru',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 4,
    },
    {
        id: '7457878f-d566-46b5-802c-edaa269e4173',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T08:05:00',
        till: '2022-10-18T08:40:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Mauritius',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 3,
    },
    {
        id: 'e9dc3e65-046d-4108-969b-2aab4fba0225',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        since: '2022-10-18T08:40:00',
        till: '2022-10-18T09:10:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'Uzbekistan',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 4,
    },
    {
        id: '3dc17a7c-308a-468a-8aaf-37843a70df14',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        since: '2022-10-18T09:10:00',
        till: '2022-10-18T09:40:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'Bahamas',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 1,
    },
    {
        id: '9902b7e5-269d-4242-8474-71f7c358e76e',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T09:40:00',
        till: '2022-10-18T10:15:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Belize',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 3,
    },
    {
        id: '080c273f-c76c-4b44-bcdc-9a7dcec92609',
        description:
            'During a perilous 24-hour mission on the moon, space explorers try to retrieve samples from an abandoned research facility steeped in classified secrets.',
        title: 'The Silent Sea',
        since: '2022-10-18T10:15:00',
        till: '2022-10-18T10:45:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/9hNJ3fvIVd4WE3rU1Us2awoTpgM.jpg',
        country: 'Lesotho',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '24 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Adventure, Drama, Mystery',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Bae Doona, Gong Yoo, Joon Lee',
        Language: 'Korean',
        Country: 'South Korea',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '6.9',
        imdbVotes: '13,008',
        imdbID: 'tt11570202',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.9/10' }],
        rating: 1,
    },
    {
        id: '8b12b5d5-897a-471a-b1a6-bf713308628d',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T10:45:00',
        till: '2022-10-18T11:50:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Guadeloupe',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 1,
    },
    {
        id: '1b856e77-3c69-4365-9d6e-b668560403b2',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T11:50:00',
        till: '2022-10-18T12:50:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Lesotho',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 5,
    },
    {
        id: '50e0f11a-37ae-4f96-849c-3459146f2571',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T12:50:00',
        till: '2022-10-18T13:20:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Bolivia',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 3,
    },
    {
        id: '1fc6795f-b365-4062-beec-5ee1f8cbb560',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T13:20:00',
        till: '2022-10-18T13:50:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Libya',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 1,
    },
    {
        id: 'b869d01a-f68d-4454-8d07-50f077bc4ca5',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T13:50:00',
        till: '2022-10-18T14:05:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Vanuatu',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 1,
    },
    {
        id: 'c71dcc90-410a-4e85-b8fc-861fccaaf9a4',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T14:05:00',
        till: '2022-10-18T15:05:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Barbados',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 5,
    },
    {
        id: '61db3333-9a0b-4d1e-ba30-70fa87c58954',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T15:05:00',
        till: '2022-10-18T16:15:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'Vatican City',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 2,
    },
    {
        id: 'a07c30cc-0268-4a6c-a6e8-4815a602a482',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T16:15:00',
        till: '2022-10-18T17:10:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Vanuatu',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 4,
    },
    {
        id: 'da91ff76-c0d5-41e8-b13e-bde4ba15f574',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T17:10:00',
        till: '2022-10-18T17:40:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Belize',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 5,
    },
    {
        id: '178c24f1-b7bd-4cf5-8124-2e7fd912fc7d',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T17:40:00',
        till: '2022-10-18T18:20:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Solomon Islands',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 3,
    },
    {
        id: '2a21a9fa-48b6-4a09-90e0-410d7c422818',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T18:20:00',
        till: '2022-10-18T18:55:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Kuwait',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 2,
    },
    {
        id: '2797e7f0-3230-4b24-b319-f8e79220a7f6',
        description:
            "A hedonistic jingle writer's free-wheeling life comes to an abrupt halt when his brother and 10-year-old nephew move into his beach-front house.",
        title: 'Two and a Half Men',
        since: '2022-10-18T18:55:00',
        till: '2022-10-18T19:55:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/lW3r6Fb7dwZ0bpGwjYHMVkgSVRt.jpg',
        country: 'South Georgia and the South Sandwich Islands',
        Year: '2003–2015',
        Rated: 'TV-14',
        Released: '22 Sep 2003',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Lee Aronsohn, Chuck Lorre',
        Actors: 'Jon Cryer, Ashton Kutcher, Angus T. Jones',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 9 Primetime Emmys. 30 wins & 72 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.0',
        imdbVotes: '253,658',
        imdbID: 'tt0369179',
        Type: 'series',
        totalSeasons: '12',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.0/10' }],
        rating: 2,
    },
    {
        id: '8a3e5a35-5cb4-4cce-8d5e-6aeafa2fbd8e',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T19:55:00',
        till: '2022-10-18T20:55:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Guadeloupe',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: '858c9137-5904-4525-99bb-fc481ad6c151',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T20:55:00',
        till: '2022-10-18T21:55:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Indonesia',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 4,
    },
    {
        id: '8a714d78-3519-426a-a637-91f6661e4b30',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T21:55:00',
        till: '2022-10-18T23:35:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Guyana',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 3,
    },
    {
        id: '7ca61d3c-4881-42dd-b496-3b8cbfe0334b',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T23:35:00',
        isTomorrow: true,
        till: '2022-10-19T00:45:00',
        channelUuid: '359563a3-3bbb-40f7-8a55-bec3b11180c4',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Neutral Zone',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: 'ca3e3de0-28d6-46cc-8121-5f63ebe143e1',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        isYesterday: true,
        since: '2022-10-17T23:50:00',
        till: '2022-10-18T00:45:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Sweden',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 1,
    },
    {
        id: '1f1135dd-35b2-445b-b4be-5a031ca540f2',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T00:45:00',
        till: '2022-10-18T01:45:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Gambia',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 2,
    },
    {
        id: 'ce103771-f059-4fd0-b38e-1ed7a402800a',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T01:45:00',
        till: '2022-10-18T02:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'France',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 1,
    },
    {
        id: 'bec10da2-7cd1-464b-a860-f6e77e4801d6',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T02:00:00',
        till: '2022-10-18T02:35:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Isle of Man',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 1,
    },
    {
        id: '04756eb2-ce06-4930-ae49-06d13f62ea46',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T02:35:00',
        till: '2022-10-18T03:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Guatemala',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 4,
    },
    {
        id: '25dbb897-4ef3-494e-ab9b-3935a428e57c',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T03:00:00',
        till: '2022-10-18T04:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Tajikistan',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 2,
    },
    {
        id: '2a7da928-a3b1-4642-b348-f097b41cd608',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T04:00:00',
        till: '2022-10-18T05:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Ireland',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 4,
    },
    {
        id: '2e2d0e80-c58c-4dd4-a601-3464a0514e7d',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T05:00:00',
        till: '2022-10-18T06:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Maldives',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 2,
    },
    {
        id: 'd04af3b8-adda-4dc2-87a0-f628b61c855f',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T06:00:00',
        till: '2022-10-18T07:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Hong Kong SAR China',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 3,
    },
    {
        id: 'a5db55e6-4014-4f83-a04d-61f94c67bbdf',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T07:00:00',
        till: '2022-10-18T08:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Macau SAR China',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 5,
    },
    {
        id: '529285f4-5de0-4333-808c-c738f4a3b9bc',
        description:
            "A hedonistic jingle writer's free-wheeling life comes to an abrupt halt when his brother and 10-year-old nephew move into his beach-front house.",
        title: 'Two and a Half Men',
        since: '2022-10-18T08:00:00',
        till: '2022-10-18T09:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/lW3r6Fb7dwZ0bpGwjYHMVkgSVRt.jpg',
        country: 'Nicaragua',
        Year: '2003–2015',
        Rated: 'TV-14',
        Released: '22 Sep 2003',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Lee Aronsohn, Chuck Lorre',
        Actors: 'Jon Cryer, Ashton Kutcher, Angus T. Jones',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 9 Primetime Emmys. 30 wins & 72 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.0',
        imdbVotes: '253,658',
        imdbID: 'tt0369179',
        Type: 'series',
        totalSeasons: '12',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.0/10' }],
        rating: 3,
    },
    {
        id: '8e8c9453-485a-49b9-af39-05f2e7cf53b2',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T09:00:00',
        till: '2022-10-18T10:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Ireland',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 3,
    },
    {
        id: 'd23c3403-a1cf-48aa-816c-2c90390f33f5',
        description:
            "A hedonistic jingle writer's free-wheeling life comes to an abrupt halt when his brother and 10-year-old nephew move into his beach-front house.",
        title: 'Two and a Half Men',
        since: '2022-10-18T10:00:00',
        till: '2022-10-18T11:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/lW3r6Fb7dwZ0bpGwjYHMVkgSVRt.jpg',
        country: 'Tonga',
        Year: '2003–2015',
        Rated: 'TV-14',
        Released: '22 Sep 2003',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Lee Aronsohn, Chuck Lorre',
        Actors: 'Jon Cryer, Ashton Kutcher, Angus T. Jones',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 9 Primetime Emmys. 30 wins & 72 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.0',
        imdbVotes: '253,658',
        imdbID: 'tt0369179',
        Type: 'series',
        totalSeasons: '12',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.0/10' }],
        rating: 3,
    },
    {
        id: '4dee4eb6-64ff-4b25-af31-fd3ee47cc77a',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T11:00:00',
        till: '2022-10-18T12:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Dominican Republic',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 2,
    },
    {
        id: '2094b84e-6b6f-4149-bc6c-dac5a91fc38f',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T12:00:00',
        till: '2022-10-18T13:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Bangladesh',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 1,
    },
    {
        id: '1050e7aa-6b5c-4b9e-b552-a3e7ca20b4b3',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T13:00:00',
        till: '2022-10-18T14:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Greece',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 4,
    },
    {
        id: '831b65fd-df94-4d40-aad1-2b77b4d0ee5e',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T14:00:00',
        till: '2022-10-18T14:20:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Cayman Islands',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 2,
    },
    {
        id: '9b97ecbd-9b0f-4e77-98f8-ca6197866b2e',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T14:20:00',
        till: '2022-10-18T15:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Bosnia and Herzegovina',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 2,
    },
    {
        id: 'a416f770-420b-444c-9598-8888e202d3f3',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T15:00:00',
        till: '2022-10-18T16:00:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Cook Islands',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 3,
    },
    {
        id: 'a13f572f-0f4c-43c6-af83-ed1bcce4c7ef',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T16:00:00',
        till: '2022-10-18T17:50:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Sierra Leone',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 3,
    },
    {
        id: 'c52c98da-745a-4a59-98a8-22d82549714d',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T17:50:00',
        till: '2022-10-18T18:50:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'Ukraine',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 2,
    },
    {
        id: '935e20b6-f8ad-4156-a353-7b77a4aba20e',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T18:50:00',
        till: '2022-10-18T19:50:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Pakistan',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 3,
    },
    {
        id: '59d0ab89-0c0a-4647-8af7-5f80a7822274',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T19:50:00',
        till: '2022-10-18T20:50:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Russia',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 5,
    },
    {
        id: '6ffd4f0b-3eca-4cc4-8a1e-f0a9990fbe09',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T20:50:00',
        till: '2022-10-18T21:50:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'South Africa',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 3,
    },
    {
        id: 'df13cfdd-acc4-4883-9b4a-251af8d9a803',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T21:50:00',
        till: '2022-10-18T22:50:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Greece',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 1,
    },
    {
        id: '805e8386-4d68-4ba8-bc22-a737bc09757d',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T22:50:00',
        till: '2022-10-18T23:50:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Heard Island and McDonald Islands',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 5,
    },
    {
        id: '599413fe-2406-4184-ae5d-5ad2cae75d2d',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T23:50:00',
        isTomorrow: true,
        till: '2022-10-19T00:45:00',
        channelUuid: '21dda491-f640-4db5-9172-d35eedd06ea5',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'Christmas Island',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 3,
    },
    {
        id: 'c02b08bd-9580-404b-865f-801c1565abe1',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T00:00:00',
        till: '2022-10-18T01:00:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Greenland',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 4,
    },
    {
        id: 'f398d8f2-9850-468c-9622-a9f66e14106c',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T01:00:00',
        till: '2022-10-18T01:45:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Honduras',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 2,
    },
    {
        id: 'e68f9062-9d2f-43b5-a8c9-5d9933a2b834',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T01:45:00',
        till: '2022-10-18T02:50:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Bosnia and Herzegovina',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 4,
    },
    {
        id: '8435706a-fef5-44f9-85b4-a47888823b99',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T02:50:00',
        till: '2022-10-18T03:50:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Montenegro',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 2,
    },
    {
        id: '6403d82c-86cd-4021-a21f-bc04ea5187b5',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T03:50:00',
        till: '2022-10-18T05:10:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Dominica',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 2,
    },
    {
        id: '557e1fc2-1754-4408-83e7-5a5446529c9b',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T05:10:00',
        till: '2022-10-18T05:55:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Serbia and Montenegro',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: 'bcfa8cfe-b957-4bd4-8299-dea30f575163',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        since: '2022-10-18T05:55:00',
        till: '2022-10-18T07:00:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'Japan',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 3,
    },
    {
        id: '4aec2573-8803-42df-9f24-6d7445b8762f',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T07:00:00',
        till: '2022-10-18T09:00:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Swaziland',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 3,
    },
    {
        id: '7f57afc9-9287-4777-be48-cc4dc9ea2d10',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T09:00:00',
        till: '2022-10-18T09:05:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Germany',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 5,
    },
    {
        id: '46f3bade-dd60-4149-8aef-f1f78f389072',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T09:05:00',
        till: '2022-10-18T09:45:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Bahamas',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 1,
    },
    {
        id: '558487e4-3017-4f58-ab83-1f1862d0ff12',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T09:45:00',
        till: '2022-10-18T09:58:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Puerto Rico',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 5,
    },
    {
        id: '4900aef0-6f2e-47ba-937a-1e297a25224b',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T09:58:00',
        till: '2022-10-18T10:00:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'China',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 3,
    },
    {
        id: '32e261ee-d38e-497b-ad0c-6b2236d7bc73',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T10:00:00',
        till: '2022-10-18T10:35:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Guatemala',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 5,
    },
    {
        id: 'b95ece13-b7c4-400d-b9e9-eea8d2a0612f',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T10:35:00',
        till: '2022-10-18T11:30:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Palestinian Territories',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 5,
    },
    {
        id: 'b98ede62-db7f-4557-b70f-cbb9a85dfc50',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T11:30:00',
        till: '2022-10-18T12:35:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'United Arab Emirates',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 4,
    },
    {
        id: 'fd878c5e-6a67-4f91-92e2-ad9853c89f19',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T12:35:00',
        till: '2022-10-18T13:05:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Haiti',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 5,
    },
    {
        id: '1faca08c-3ba6-4ed9-8e09-bf547ae91d8f',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T13:05:00',
        till: '2022-10-18T13:35:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Latvia',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 2,
    },
    {
        id: '1410b2b2-1903-40d6-9439-96cb47a4edb3',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T13:35:00',
        till: '2022-10-18T14:35:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Norfolk Island',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 4,
    },
    {
        id: 'b82bd633-8e84-42c5-ac0e-6ed201f59766',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T14:35:00',
        till: '2022-10-18T15:45:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Suriname',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 3,
    },
    {
        id: 'c6fa831e-e907-4841-b7d1-6948fa98d167',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T15:45:00',
        till: '2022-10-18T16:00:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'United States',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 1,
    },
    {
        id: 'aff9a275-6571-4650-aaea-839d3fbca894',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T16:00:00',
        till: '2022-10-18T16:05:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Guadeloupe',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 2,
    },
    {
        id: 'c9254ed2-8560-442c-ae1b-9f1d128a1a38',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T16:05:00',
        till: '2022-10-18T16:55:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Chile',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 5,
    },
    {
        id: '237f86e7-c3d5-41fc-a6b4-0cb4d526b1e5',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T16:55:00',
        till: '2022-10-18T17:45:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'Argentina',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 1,
    },
    {
        id: '9f599724-a0d8-4e51-b1eb-3e4763513033',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T17:45:00',
        till: '2022-10-18T17:58:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Madagascar',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 2,
    },
    {
        id: '2754ae5d-42bb-4237-aa81-dcb99104785d',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T17:58:00',
        till: '2022-10-18T18:00:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Spain',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 2,
    },
    {
        id: '11894439-a85f-4796-81de-c1c2234e5730',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T18:00:00',
        till: '2022-10-18T18:30:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Wallis and Futuna',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 2,
    },
    {
        id: 'cceca206-b8f1-470d-9a9a-0042c98569b3',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T18:30:00',
        till: '2022-10-18T19:00:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Wallis and Futuna',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 5,
    },
    {
        id: '7123feaa-fb0c-41dc-a4bc-0132e7cb6bf6',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T19:00:00',
        till: '2022-10-18T19:40:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Laos',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 5,
    },
    {
        id: '429dc8b9-3a79-4b15-a582-c538b5e11cc6',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T19:40:00',
        till: '2022-10-18T19:45:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Saint Barthélemy',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 4,
    },
    {
        id: 'cc671ab7-0c7f-4e58-86f3-8b4a1c7f8009',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T19:45:00',
        till: '2022-10-18T19:58:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Bosnia and Herzegovina',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 3,
    },
    {
        id: '6c553be8-c148-4828-8e2d-5ce8a9a33c99',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T19:58:00',
        till: '2022-10-18T20:00:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Tunisia',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 2,
    },
    {
        id: 'd556a6e2-f560-42a8-8c5d-cc55a11b811d',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        since: '2022-10-18T20:00:00',
        till: '2022-10-18T21:00:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'British Virgin Islands',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 5,
    },
    {
        id: 'b944d224-e2d9-426b-a4ca-ab5b1f07753b',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T21:00:00',
        till: '2022-10-18T21:30:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'New Zealand',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 5,
    },
    {
        id: '5381c4ce-5250-430c-8755-8375b1122ac0',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T21:30:00',
        till: '2022-10-18T22:00:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Greenland',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 4,
    },
    {
        id: 'e00466cf-a417-45b9-aff3-2c37f63bcb05',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T22:00:00',
        till: '2022-10-18T22:50:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Luxembourg',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 5,
    },
    {
        id: 'fc8916a4-dc24-4ed3-93f8-587ff3b9d812',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T22:50:00',
        till: '2022-10-18T23:50:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Syria',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 3,
    },
    {
        id: 'c4dedd5b-93d3-445b-b3b3-87a48f2d7db8',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T23:50:00',
        isTomorrow: true,
        till: '2022-10-19T00:50:00',
        channelUuid: 'd75873f4-4f2c-46f6-b6d6-65cfa62b8cf7',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Åland Islands',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 3,
    },
    {
        id: '574a60de-4e64-49f0-aa6c-63a437d60b17',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        isYesterday: true,
        since: '2022-10-17T23:00:00',
        till: '2022-10-18T01:20:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Puerto Rico',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 3,
    },
    {
        id: 'aadc49f9-60fd-4de7-898d-5255a154db12',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T01:20:00',
        till: '2022-10-18T01:45:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Costa Rica',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 3,
    },
    {
        id: 'be2f417f-b7eb-417f-889b-53c7263b8b76',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T01:45:00',
        till: '2022-10-18T02:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Bangladesh',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 5,
    },
    {
        id: '459bd0b3-8d9c-4830-b684-72700f01c4ed',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T02:00:00',
        till: '2022-10-18T02:45:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'Zimbabwe',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 5,
    },
    {
        id: 'f4a0246d-a2cc-4ea1-bbbc-1b647a4e62f5',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T02:45:00',
        till: '2022-10-18T03:15:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Norway',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 2,
    },
    {
        id: '2f17521b-b283-479e-baac-6ef1b99e611c',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T03:15:00',
        till: '2022-10-18T03:45:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Solomon Islands',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 4,
    },
    {
        id: 'bc00e627-bbd4-4c1b-b5d5-45eab8bc03af',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T03:45:00',
        till: '2022-10-18T04:15:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Suriname',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 4,
    },
    {
        id: 'b33cf059-efb4-4a8e-bd04-5f8bf434c217',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T04:15:00',
        till: '2022-10-18T04:45:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Panama',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 2,
    },
    {
        id: '1fcb42f2-24e6-48b9-9fbb-898e4db19abe',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T04:45:00',
        till: '2022-10-18T05:15:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Spain',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 4,
    },
    {
        id: '350d35a8-b6cf-4dbc-95e8-797d3be64ff0',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T05:15:00',
        till: '2022-10-18T05:45:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Saint Kitts and Nevis',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 2,
    },
    {
        id: 'b125adc1-6f0e-495c-a99d-c34b6ea14239',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T05:45:00',
        till: '2022-10-18T06:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'Chile',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 2,
    },
    {
        id: '7367a43f-3e10-4d4e-94f6-03a4e6149d51',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T06:00:00',
        till: '2022-10-18T07:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Dominican Republic',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 2,
    },
    {
        id: '384edb64-62ca-4d91-8f1a-535cb8541911',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T07:00:00',
        till: '2022-10-18T08:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Montserrat',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 4,
    },
    {
        id: 'be746b76-2121-4403-b3b0-0e801391effd',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T08:00:00',
        till: '2022-10-18T09:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Belize',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 3,
    },
    {
        id: '01dc68b5-cf72-4cb3-bfbd-9551e5d34cdf',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T09:00:00',
        till: '2022-10-18T10:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'Gabon',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 5,
    },
    {
        id: '679da34a-5370-466e-8bd8-a985933ae4c5',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T10:00:00',
        till: '2022-10-18T11:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Nauru',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 2,
    },
    {
        id: 'e03510a7-3c19-4e49-a0ba-d7f2a6dfe8d2',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T11:00:00',
        till: '2022-10-18T12:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Wallis and Futuna',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 3,
    },
    {
        id: 'b4e63a64-0ea9-4562-813f-e84ecc3b5ae2',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T12:00:00',
        till: '2022-10-18T13:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Cayman Islands',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 2,
    },
    {
        id: 'b4e2b0ad-00f7-415a-a681-a5d52a0f5939',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T13:00:00',
        till: '2022-10-18T14:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Saint Vincent and the Grenadines',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 3,
    },
    {
        id: 'f2f00373-7f5f-425b-a7c6-79f6b95f3f23',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T14:00:00',
        till: '2022-10-18T15:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Anguilla',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 5,
    },
    {
        id: 'cb047457-ba13-486c-a550-15cf46b25c52',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T15:00:00',
        till: '2022-10-18T16:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Serbia',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 3,
    },
    {
        id: 'd3f00d46-0702-4d0e-8b08-a9ead1d26894',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T16:00:00',
        till: '2022-10-18T17:35:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Jersey',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 2,
    },
    {
        id: '520195e4-6c93-4ccb-94f3-1663b2f170a0',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T17:35:00',
        till: '2022-10-18T19:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Bahrain',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: 'a2e9efdc-25f8-48ba-b871-8a82b209c099',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T19:00:00',
        till: '2022-10-18T19:35:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Moldova',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 5,
    },
    {
        id: 'bcece427-9c12-4d63-a5aa-bd20e80ace4c',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T19:35:00',
        till: '2022-10-18T20:05:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Armenia',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 2,
    },
    {
        id: '1e68abf7-943f-49b5-b46a-ef4b12456657',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T20:05:00',
        till: '2022-10-18T21:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Mali',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 3,
    },
    {
        id: '7b3a8273-f561-476f-9026-2f1938a904d9',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T21:00:00',
        till: '2022-10-18T23:30:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Nigeria',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 5,
    },
    {
        id: '53955355-2c61-4a88-a67b-b2f6d5daa653',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T23:30:00',
        isTomorrow: true,
        till: '2022-10-19T02:00:00',
        channelUuid: 'a7238d3d-f1e6-4934-a663-37c1902920cd',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Ghana',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 2,
    },
    {
        id: '292c0ffe-5790-4286-812b-342854f4f4f6',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        isYesterday: true,
        since: '2022-10-17T23:10:00',
        till: '2022-10-18T02:15:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Armenia',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 4,
    },
    {
        id: '0bf6bc40-621f-46c0-b896-cb68858674cd',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T02:15:00',
        till: '2022-10-18T04:40:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'North Vietnam',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: '7ecb59b4-3cfb-449f-a99c-19d0eb938162',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T04:40:00',
        till: '2022-10-18T05:25:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Egypt',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 3,
    },
    {
        id: '765993c1-3e95-46fa-b891-87843b1e00a7',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T05:25:00',
        till: '2022-10-18T06:00:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Chad',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 4,
    },
    {
        id: '8083aed8-3318-4b28-8b38-66fdf2a2b90f',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T06:00:00',
        till: '2022-10-18T08:25:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Mozambique',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 5,
    },
    {
        id: 'c84bcc01-98c4-43f4-85db-61999988198b',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T08:25:00',
        till: '2022-10-18T10:10:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Niue',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 1,
    },
    {
        id: '7f2f4005-cc59-43fa-9dec-962f2fd0481f',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T10:10:00',
        till: '2022-10-18T10:40:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Bhutan',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 2,
    },
    {
        id: '4bf9f28e-b832-437d-a6f3-9a9a1fedde53',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T10:40:00',
        till: '2022-10-18T11:40:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Bahamas',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 4,
    },
    {
        id: '625389aa-3754-460a-9baa-5a8523327abd',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T11:40:00',
        till: '2022-10-18T12:40:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Finland',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 4,
    },
    {
        id: '64462bfc-3c5b-4935-9607-a7e06512af4a',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T12:40:00',
        till: '2022-10-18T13:45:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Bangladesh',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: '99078f57-67a6-4af1-bf1a-01965b892e7c',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T13:45:00',
        till: '2022-10-18T14:15:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Japan',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 1,
    },
    {
        id: '9ff170c7-da46-4302-9cf9-ad12f7b99440',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T14:15:00',
        till: '2022-10-18T14:40:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Denmark',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 1,
    },
    {
        id: '80a2be3c-9cc6-4e12-bd8b-31dd887f4d16',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T14:40:00',
        till: '2022-10-18T15:45:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Turkey',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 5,
    },
    {
        id: '5de3a129-2ff5-41c7-9560-b2d05557746d',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T15:45:00',
        till: '2022-10-18T16:15:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Kenya',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 5,
    },
    {
        id: '015e5047-77e8-4713-966a-7aedda73ee0d',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T16:15:00',
        till: '2022-10-18T16:45:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Comoros',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 2,
    },
    {
        id: '472a4473-594c-4240-9b5e-440f9e7cc09a',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        since: '2022-10-18T16:45:00',
        till: '2022-10-18T17:15:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'Cocos [Keeling] Islands',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 3,
    },
    {
        id: '15a9b6ed-7efe-441a-a4e6-204c26867476',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T17:15:00',
        till: '2022-10-18T17:45:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Uruguay',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 3,
    },
    {
        id: '5d9cb958-2739-43aa-8231-c7a85aa2719f',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T17:45:00',
        till: '2022-10-18T18:15:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'San Marino',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 3,
    },
    {
        id: '1712479e-72f9-4a6b-8e61-b7505800e018',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T18:15:00',
        till: '2022-10-18T18:50:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Luxembourg',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 5,
    },
    {
        id: '94545189-ad6c-42f3-97dd-0df01b447126',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T18:50:00',
        till: '2022-10-18T19:25:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'American Samoa',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 2,
    },
    {
        id: 'efa15fbd-28ad-4e2a-b08e-5cf5027b8f7d',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T19:25:00',
        till: '2022-10-18T19:45:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Croatia',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 5,
    },
    {
        id: 'e544f98c-a6f7-4484-a2a2-dbee75a3a954',
        description:
            "A hedonistic jingle writer's free-wheeling life comes to an abrupt halt when his brother and 10-year-old nephew move into his beach-front house.",
        title: 'Two and a Half Men',
        since: '2022-10-18T19:45:00',
        till: '2022-10-18T19:55:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/lW3r6Fb7dwZ0bpGwjYHMVkgSVRt.jpg',
        country: 'Ireland',
        Year: '2003–2015',
        Rated: 'TV-14',
        Released: '22 Sep 2003',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Lee Aronsohn, Chuck Lorre',
        Actors: 'Jon Cryer, Ashton Kutcher, Angus T. Jones',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 9 Primetime Emmys. 30 wins & 72 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.0',
        imdbVotes: '253,658',
        imdbID: 'tt0369179',
        Type: 'series',
        totalSeasons: '12',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.0/10' }],
        rating: 3,
    },
    {
        id: 'c707d3a8-6c6d-4871-8b11-0252e1f81cf6',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T19:55:00',
        till: '2022-10-18T20:00:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Sri Lanka',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 3,
    },
    {
        id: 'a66ad4b1-34ac-4c94-a380-94da57711588',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T20:00:00',
        till: '2022-10-18T22:00:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Tuvalu',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 2,
    },
    {
        id: '766738db-6774-463e-84a1-9e121b001170',
        description:
            "A hedonistic jingle writer's free-wheeling life comes to an abrupt halt when his brother and 10-year-old nephew move into his beach-front house.",
        title: 'Two and a Half Men',
        since: '2022-10-18T22:00:00',
        isTomorrow: true,
        till: '2022-10-19T00:45:00',
        channelUuid: 'da5fc532-fa14-481b-91c7-0c8bc4ee91a3',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/lW3r6Fb7dwZ0bpGwjYHMVkgSVRt.jpg',
        country: 'Svalbard and Jan Mayen',
        Year: '2003–2015',
        Rated: 'TV-14',
        Released: '22 Sep 2003',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Lee Aronsohn, Chuck Lorre',
        Actors: 'Jon Cryer, Ashton Kutcher, Angus T. Jones',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 9 Primetime Emmys. 30 wins & 72 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.0',
        imdbVotes: '253,658',
        imdbID: 'tt0369179',
        Type: 'series',
        totalSeasons: '12',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.0/10' }],
        rating: 5,
    },
    {
        id: 'fd290793-8a9e-4dbd-ba7f-16f256277de3',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        isYesterday: true,
        since: '2022-10-17T23:50:00',
        till: '2022-10-18T00:45:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Sweden',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 3,
    },
    {
        id: '3ab25340-a8ff-4143-8abc-70844a6340b8',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T00:45:00',
        till: '2022-10-18T01:45:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Gambia',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 4,
    },
    {
        id: '0444390c-41b5-4d91-9479-a015bc0a5bc9',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T01:45:00',
        till: '2022-10-18T02:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'France',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 3,
    },
    {
        id: 'b603759a-5cfc-4e48-81b3-7c989c3982e1',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T02:00:00',
        till: '2022-10-18T02:35:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Isle of Man',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 3,
    },
    {
        id: '3ae98d60-d601-4329-b203-8720cda3a70f',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T02:35:00',
        till: '2022-10-18T03:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Guatemala',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 4,
    },
    {
        id: '7b6829ce-bfec-41ea-ad95-8d6095b055b2',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T03:00:00',
        till: '2022-10-18T04:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Tajikistan',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 1,
    },
    {
        id: '512b431d-d615-4e00-838f-101a263c219b',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T04:00:00',
        till: '2022-10-18T05:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Ireland',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 5,
    },
    {
        id: 'c3a1c338-3a1e-47cf-881d-d7c68d566b37',
        description:
            "A hedonistic jingle writer's free-wheeling life comes to an abrupt halt when his brother and 10-year-old nephew move into his beach-front house.",
        title: 'Two and a Half Men',
        since: '2022-10-18T05:00:00',
        till: '2022-10-18T06:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/lW3r6Fb7dwZ0bpGwjYHMVkgSVRt.jpg',
        country: 'Maldives',
        Year: '2003–2015',
        Rated: 'TV-14',
        Released: '22 Sep 2003',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Lee Aronsohn, Chuck Lorre',
        Actors: 'Jon Cryer, Ashton Kutcher, Angus T. Jones',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 9 Primetime Emmys. 30 wins & 72 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.0',
        imdbVotes: '253,658',
        imdbID: 'tt0369179',
        Type: 'series',
        totalSeasons: '12',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.0/10' }],
        rating: 3,
    },
    {
        id: '66f6dbd5-0df5-4b67-822d-8a2f25699ad1',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T06:00:00',
        till: '2022-10-18T07:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Hong Kong SAR China',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 5,
    },
    {
        id: '50c57fe9-86a3-41ca-9f88-0f0e4141fa5c',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T07:00:00',
        till: '2022-10-18T08:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Macau SAR China',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 5,
    },
    {
        id: '6a16c2dd-d3b3-41d6-8615-01d12324c985',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T08:00:00',
        till: '2022-10-18T09:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Nicaragua',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: '5a827ba7-98fa-4c12-916e-5becb84f8076',
        description:
            'During a perilous 24-hour mission on the moon, space explorers try to retrieve samples from an abandoned research facility steeped in classified secrets.',
        title: 'The Silent Sea',
        since: '2022-10-18T09:00:00',
        till: '2022-10-18T10:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/9hNJ3fvIVd4WE3rU1Us2awoTpgM.jpg',
        country: 'Ireland',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '24 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Adventure, Drama, Mystery',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Bae Doona, Gong Yoo, Joon Lee',
        Language: 'Korean',
        Country: 'South Korea',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '6.9',
        imdbVotes: '13,008',
        imdbID: 'tt11570202',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.9/10' }],
        rating: 3,
    },
    {
        id: 'ab009b4c-0032-4a5f-a14a-ec1f4f3ec50c',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T10:00:00',
        till: '2022-10-18T11:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Tonga',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 2,
    },
    {
        id: 'e1df18c3-332f-4ae7-b0d5-fefe11aef1fe',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T11:00:00',
        till: '2022-10-18T12:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'Dominican Republic',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 3,
    },
    {
        id: '3acdad68-ad56-4722-9049-a99a95f72710',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T12:00:00',
        till: '2022-10-18T13:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Bangladesh',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 5,
    },
    {
        id: '8d74ba49-c360-44db-b0c8-77da446447b9',
        description:
            'During a perilous 24-hour mission on the moon, space explorers try to retrieve samples from an abandoned research facility steeped in classified secrets.',
        title: 'The Silent Sea',
        since: '2022-10-18T13:00:00',
        till: '2022-10-18T14:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/9hNJ3fvIVd4WE3rU1Us2awoTpgM.jpg',
        country: 'Greece',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '24 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Adventure, Drama, Mystery',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Bae Doona, Gong Yoo, Joon Lee',
        Language: 'Korean',
        Country: 'South Korea',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '6.9',
        imdbVotes: '13,008',
        imdbID: 'tt11570202',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.9/10' }],
        rating: 2,
    },
    {
        id: '3fda42a4-c524-475f-af82-6553cbfc1c83',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T14:00:00',
        till: '2022-10-18T14:20:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Cayman Islands',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 4,
    },
    {
        id: 'e9d7c216-dea3-493c-a7c9-0f6eba327504',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T14:20:00',
        till: '2022-10-18T15:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Bosnia and Herzegovina',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 1,
    },
    {
        id: 'ca5d89fa-a652-42bb-880a-e552bf3fdf9f',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T15:00:00',
        till: '2022-10-18T16:00:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Cook Islands',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 2,
    },
    {
        id: '2e121880-d160-4c27-9af5-f5a983403820',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T16:00:00',
        till: '2022-10-18T17:50:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Sierra Leone',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 5,
    },
    {
        id: 'dbbef29c-2994-438e-8cdd-a5d9a6a77e37',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T17:50:00',
        till: '2022-10-18T18:50:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Ukraine',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 3,
    },
    {
        id: '38d18367-fa4c-4c4a-bdf5-f325153df7c4',
        description:
            "A hedonistic jingle writer's free-wheeling life comes to an abrupt halt when his brother and 10-year-old nephew move into his beach-front house.",
        title: 'Two and a Half Men',
        since: '2022-10-18T18:50:00',
        till: '2022-10-18T19:50:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/lW3r6Fb7dwZ0bpGwjYHMVkgSVRt.jpg',
        country: 'Pakistan',
        Year: '2003–2015',
        Rated: 'TV-14',
        Released: '22 Sep 2003',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Lee Aronsohn, Chuck Lorre',
        Actors: 'Jon Cryer, Ashton Kutcher, Angus T. Jones',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 9 Primetime Emmys. 30 wins & 72 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.0',
        imdbVotes: '253,658',
        imdbID: 'tt0369179',
        Type: 'series',
        totalSeasons: '12',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.0/10' }],
        rating: 4,
    },
    {
        id: 'ea09c775-ccb4-4a76-8aaa-07a811293146',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T19:50:00',
        till: '2022-10-18T20:50:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Russia',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 3,
    },
    {
        id: 'adc6bd51-ed18-480a-ac94-d6006115445f',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T20:50:00',
        till: '2022-10-18T21:50:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'South Africa',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: '22a6a236-0ae0-4ba3-8910-47538ed44290',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T21:50:00',
        till: '2022-10-18T22:50:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Greece',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 2,
    },
    {
        id: 'a93b2861-60fd-4709-a5d6-2b42046112f0',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T22:50:00',
        till: '2022-10-18T23:50:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Heard Island and McDonald Islands',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 2,
    },
    {
        id: '869ce2df-85c8-4dbc-946a-dc718f09141d',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T23:50:00',
        isTomorrow: true,
        till: '2022-10-19T00:45:00',
        channelUuid: 'bbd592e8-bd97-4889-915d-3c4b14788cfb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Christmas Island',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 3,
    },
    {
        id: 'b5f90af3-0655-4bbb-8409-a84e01ccc442',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        isYesterday: true,
        since: '2022-10-17T23:10:00',
        till: '2022-10-18T01:35:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Colombia',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 4,
    },
    {
        id: 'b7c1bce0-16bd-4717-901f-c4743f157f95',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T01:35:00',
        till: '2022-10-18T03:45:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Brazil',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 1,
    },
    {
        id: 'f590f7c4-ab4a-4f6f-b534-fcab8b823637',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T03:45:00',
        till: '2022-10-18T05:15:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'Isle of Man',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 2,
    },
    {
        id: '281f4493-e100-4e21-b3c3-6b40d6ad16b3',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T05:15:00',
        till: '2022-10-18T05:20:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Spain',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 3,
    },
    {
        id: '8316febb-63c6-43db-b3ba-ff9bd7e376e6',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T05:20:00',
        till: '2022-10-18T05:50:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Estonia',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 4,
    },
    {
        id: 'd65fe6e0-1833-44c4-8c7e-1533d8301220',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T05:50:00',
        till: '2022-10-18T06:25:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Israel',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: '6544218f-a11e-4a9a-96b8-71995ac7d64e',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T06:25:00',
        till: '2022-10-18T07:00:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Moldova',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 1,
    },
    {
        id: '8652aba2-c7b4-4aad-b03c-767d37738e43',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T07:00:00',
        till: '2022-10-18T07:55:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Zambia',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 1,
    },
    {
        id: 'e41ae334-71f7-4998-beeb-197c1cc1094e',
        description:
            "A hedonistic jingle writer's free-wheeling life comes to an abrupt halt when his brother and 10-year-old nephew move into his beach-front house.",
        title: 'Two and a Half Men',
        since: '2022-10-18T07:55:00',
        till: '2022-10-18T11:50:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/lW3r6Fb7dwZ0bpGwjYHMVkgSVRt.jpg',
        country: 'Niue',
        Year: '2003–2015',
        Rated: 'TV-14',
        Released: '22 Sep 2003',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Lee Aronsohn, Chuck Lorre',
        Actors: 'Jon Cryer, Ashton Kutcher, Angus T. Jones',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 9 Primetime Emmys. 30 wins & 72 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.0',
        imdbVotes: '253,658',
        imdbID: 'tt0369179',
        Type: 'series',
        totalSeasons: '12',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.0/10' }],
        rating: 1,
    },
    {
        id: 'ce69b278-ad5e-4bcd-a9e4-a33c11a92c06',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T11:50:00',
        till: '2022-10-18T12:30:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Guinea',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 1,
    },
    {
        id: 'cb3daf44-ffb3-46e8-9165-e48ba5e52db9',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T12:30:00',
        till: '2022-10-18T14:00:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'U.S. Minor Outlying Islands',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 4,
    },
    {
        id: '50c59515-b9f5-4ff9-8c4a-fad5940f7480',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T14:00:00',
        till: '2022-10-18T14:35:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'British Antarctic Territory',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 2,
    },
    {
        id: 'd8ded2c7-e0e5-4dc3-8277-6f0acde57178',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T14:35:00',
        till: '2022-10-18T15:15:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Saint Kitts and Nevis',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 2,
    },
    {
        id: '5eca2863-a89d-4797-b0cf-ac6408dcb084',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T15:15:00',
        till: '2022-10-18T16:15:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Costa Rica',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 1,
    },
    {
        id: '11420d0f-2b2d-4413-bd18-9da69bb16ef5',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T16:15:00',
        till: '2022-10-18T17:15:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Malaysia',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 1,
    },
    {
        id: '30b6a874-3bca-4da7-bc5a-df1854468911',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T17:15:00',
        till: '2022-10-18T17:50:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Azerbaijan',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 2,
    },
    {
        id: '9f0a13cf-a201-47e7-89c5-0cf86a377012',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T17:50:00',
        till: '2022-10-18T18:00:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Taiwan',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 2,
    },
    {
        id: 'b267ee5c-b802-4839-9792-a125c0e31e8b',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T18:00:00',
        till: '2022-10-18T18:20:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Neutral Zone',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 4,
    },
    {
        id: 'db24f48f-84d0-49c4-a38e-f8b835fc52d7',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T18:20:00',
        till: '2022-10-18T18:30:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'Uganda',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 2,
    },
    {
        id: '9729d80b-0445-4a2b-a178-3d0755fcdbfe',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T18:30:00',
        till: '2022-10-18T19:20:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Lithuania',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 3,
    },
    {
        id: '9301c28c-6be3-48ba-b689-a039834754e8',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T19:20:00',
        till: '2022-10-18T20:00:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'China',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 1,
    },
    {
        id: 'ddb9558d-1a19-41dc-a367-c3ef6af8c5e1',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T20:00:00',
        till: '2022-10-18T21:05:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'American Samoa',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 3,
    },
    {
        id: 'e49922c3-aabc-4936-abe1-a03964627ea0',
        description:
            'During a perilous 24-hour mission on the moon, space explorers try to retrieve samples from an abandoned research facility steeped in classified secrets.',
        title: 'The Silent Sea',
        since: '2022-10-18T21:05:00',
        till: '2022-10-18T22:00:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/9hNJ3fvIVd4WE3rU1Us2awoTpgM.jpg',
        country: 'Colombia',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '24 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Adventure, Drama, Mystery',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Bae Doona, Gong Yoo, Joon Lee',
        Language: 'Korean',
        Country: 'South Korea',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '6.9',
        imdbVotes: '13,008',
        imdbID: 'tt11570202',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.9/10' }],
        rating: 3,
    },
    {
        id: '6aca833e-fab7-4fb0-bd0d-c320079158f6',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T22:00:00',
        till: '2022-10-18T23:05:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Aruba',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: '4964c52f-5996-4479-8116-07284ca7354d',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T23:05:00',
        isTomorrow: true,
        till: '2022-10-19T00:15:00',
        channelUuid: '371ffac1-a5cd-4702-96b7-a35eba5edd7d',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Liechtenstein',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 1,
    },
    {
        id: '4dd648fd-aded-4167-be3e-610cbe9f3197',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        isYesterday: true,
        since: '2022-10-17T23:50:00',
        till: '2022-10-18T00:45:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Sweden',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 4,
    },
    {
        id: '86715def-604d-45d1-a7f6-1d75d41c403c',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T00:45:00',
        till: '2022-10-18T01:45:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Gambia',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 4,
    },
    {
        id: '78f13c83-d76a-4426-b356-c0469ba6411e',
        description:
            'The misadventures of a talking sea sponge who works at a fast food restaurant, attends a boating school, and lives in an underwater pineapple.',
        title: 'SpongeBob SquarePants',
        since: '2022-10-18T01:45:00',
        till: '2022-10-18T02:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/maFEWU41jdUOzDfRVkojq7fluIm.jpg',
        country: 'France',
        Year: '1999–',
        Rated: 'TV-Y',
        Released: '01 May 1999',
        Runtime: '23 min',
        Genre: 'Animation, Comedy, Family',
        Director: 'N/A',
        Writer: 'Stephen Hillenburg, Tim Hill, Nick Jennings',
        Actors: 'Tom Kenny, Bill Fagerbakke, Rodger Bumpass',
        Language: 'English, Irish Gaelic, Korean',
        Country: 'United States',
        Awards: 'Nominated for 10 Primetime Emmys. 55 wins & 63 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.2',
        imdbVotes: '91,921',
        imdbID: 'tt0206512',
        Type: 'series',
        totalSeasons: '13',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.2/10' }],
        rating: 1,
    },
    {
        id: 'a9f086bb-0a20-476f-a2e1-a01169b14810',
        description:
            "A hedonistic jingle writer's free-wheeling life comes to an abrupt halt when his brother and 10-year-old nephew move into his beach-front house.",
        title: 'Two and a Half Men',
        since: '2022-10-18T02:00:00',
        till: '2022-10-18T02:35:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/lW3r6Fb7dwZ0bpGwjYHMVkgSVRt.jpg',
        country: 'Isle of Man',
        Year: '2003–2015',
        Rated: 'TV-14',
        Released: '22 Sep 2003',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Lee Aronsohn, Chuck Lorre',
        Actors: 'Jon Cryer, Ashton Kutcher, Angus T. Jones',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 9 Primetime Emmys. 30 wins & 72 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.0',
        imdbVotes: '253,658',
        imdbID: 'tt0369179',
        Type: 'series',
        totalSeasons: '12',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.0/10' }],
        rating: 1,
    },
    {
        id: 'a5d9f1a8-93b7-45ff-bd21-7f5ad3c8f9e0',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T02:35:00',
        till: '2022-10-18T03:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Guatemala',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 2,
    },
    {
        id: '9e89fa1d-f879-453e-adc6-560f9fdf7daf',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T03:00:00',
        till: '2022-10-18T04:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Tajikistan',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 4,
    },
    {
        id: 'f20988a6-8bdd-490e-8c56-26bd0d345680',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T04:00:00',
        till: '2022-10-18T05:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Ireland',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 1,
    },
    {
        id: 'a12fc869-3185-4b9e-8578-9399f4bfe0f4',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T05:00:00',
        till: '2022-10-18T06:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Maldives',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 3,
    },
    {
        id: '7e725990-1688-426e-9035-24c8871a6453',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T06:00:00',
        till: '2022-10-18T07:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Hong Kong SAR China',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 3,
    },
    {
        id: '97e9d3b4-e111-464c-a486-7e7a5ddd15ca',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T07:00:00',
        till: '2022-10-18T08:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Macau SAR China',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 2,
    },
    {
        id: '614f1efe-f4bd-45fd-82fd-d02dd082a280',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T08:00:00',
        till: '2022-10-18T09:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Nicaragua',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 5,
    },
    {
        id: '81d50830-8eee-4d63-b9d1-3e3655df0f08',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T09:00:00',
        till: '2022-10-18T10:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Ireland',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 1,
    },
    {
        id: 'df9c74c6-3dc4-48ef-83bf-92c22a738349',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T10:00:00',
        till: '2022-10-18T11:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'Tonga',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 2,
    },
    {
        id: '254eefbb-a479-487d-b041-afdaedabdc97',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T11:00:00',
        till: '2022-10-18T12:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Dominican Republic',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 3,
    },
    {
        id: 'dbbff2f1-d334-420d-86d9-80e7afe989bc',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T12:00:00',
        till: '2022-10-18T13:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Bangladesh',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 3,
    },
    {
        id: 'cde626b8-ca2a-4d8c-894d-0d29d7727af3',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T13:00:00',
        till: '2022-10-18T14:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Greece',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 5,
    },
    {
        id: 'fca6722d-409f-4d60-a470-1ee13e5f762c',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T14:00:00',
        till: '2022-10-18T14:20:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Cayman Islands',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 3,
    },
    {
        id: '12ddf45e-d8a9-4663-a533-ca229bac2b53',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T14:20:00',
        till: '2022-10-18T15:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Bosnia and Herzegovina',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 1,
    },
    {
        id: '86bda452-d8d2-4742-b59d-916256b99390',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T15:00:00',
        till: '2022-10-18T16:00:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Cook Islands',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 2,
    },
    {
        id: '61494264-1899-4aad-8b20-0de0f40fb487',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T16:00:00',
        till: '2022-10-18T17:50:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'Sierra Leone',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 5,
    },
    {
        id: 'a9e239e2-90f6-46ec-95e2-9c3092251837',
        description:
            'An antisocial maverick doctor who specializes in diagnostic medicine does whatever it takes to solve puzzling cases that come his way using his crack team of doctors and his wits.',
        title: 'House',
        since: '2022-10-18T17:50:00',
        till: '2022-10-18T18:50:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hiK4qc0tZijQ9KNUnBIS1k4tdMJ.jpg',
        country: 'Ukraine',
        Year: '2004–2012',
        Rated: 'TV-14',
        Released: '16 Nov 2004',
        Runtime: '44 min',
        Genre: 'Drama, Mystery',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Hugh Laurie, Omar Epps, Robert Sean Leonard',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 5 Primetime Emmys. 57 wins & 140 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.7',
        imdbVotes: '439,759',
        imdbID: 'tt0412142',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.7/10' }],
        rating: 1,
    },
    {
        id: 'f7e7d8f9-f2de-4f17-90c2-0361a13125b3',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T18:50:00',
        till: '2022-10-18T19:50:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Pakistan',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 1,
    },
    {
        id: 'db64eb6b-4ade-4157-887b-3311d41a2ab3',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T19:50:00',
        till: '2022-10-18T20:50:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Russia',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 4,
    },
    {
        id: '59f84546-74c4-4888-b808-cae07054d361',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T20:50:00',
        till: '2022-10-18T21:50:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'South Africa',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 4,
    },
    {
        id: 'c1582e44-81d3-4cda-8a11-a049f06ba877',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T21:50:00',
        till: '2022-10-18T22:50:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Greece',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 2,
    },
    {
        id: '08897d3b-0bd6-473f-b388-c7b285c2112a',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T22:50:00',
        till: '2022-10-18T23:50:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Heard Island and McDonald Islands',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 1,
    },
    {
        id: '99d51e1b-beeb-4d5d-994c-143707c0a6d8',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T23:50:00',
        isTomorrow: true,
        till: '2022-10-19T00:45:00',
        channelUuid: '834bed5f-5b88-46cd-bb04-0c2cd208bccb',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Christmas Island',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 4,
    },
    {
        id: 'f6a7c3a4-4a9e-4b81-b9cf-a2f17d596c0e',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        isYesterday: true,
        since: '2022-10-17T23:50:00',
        till: '2022-10-18T00:55:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Ghana',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 5,
    },
    {
        id: 'ec2f3101-c6d2-4471-8455-0bad9e2de739',
        description: 'A gifted young teen tries to survive life with his dimwitted, dysfunctional family.',
        title: 'Malcolm in the Middle',
        since: '2022-10-18T00:55:00',
        till: '2022-10-18T02:35:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/ysaA0BInz4071p3LKqAQnWKZCsK.jpg',
        country: 'Mozambique',
        Year: '2000–2006',
        Rated: 'TV-PG',
        Released: '09 Jan 2000',
        Runtime: '22 min',
        Genre: 'Comedy, Family',
        Director: 'N/A',
        Writer: 'Linwood Boomer, Michael Glouberman, Gary Murphy',
        Actors: 'Frankie Muniz, Bryan Cranston, Justin Berfield',
        Language: 'English, Latin, Spanish, Italian, French, Chinese',
        Country: 'United States',
        Awards: 'Won 7 Primetime Emmys. 46 wins & 118 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '125,408',
        imdbID: 'tt0212671',
        Type: 'series',
        totalSeasons: '7',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 1,
    },
    {
        id: '5c45760f-52e3-42d7-925a-43aef49a2125',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T02:35:00',
        till: '2022-10-18T03:30:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Yemen',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 3,
    },
    {
        id: 'fc97ac3e-2cc3-4f68-a928-334c65b2b046',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T03:30:00',
        till: '2022-10-18T04:15:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Belarus',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 3,
    },
    {
        id: '429ef4c5-aa50-488f-9427-bc7f7bab3fa1',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T04:15:00',
        till: '2022-10-18T04:30:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Israel',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 2,
    },
    {
        id: '85c0c2c5-1f19-4fea-bd33-688e0f48e914',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T04:30:00',
        till: '2022-10-18T05:10:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Congo - Kinshasa',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: 'da668024-8602-4bda-bedd-60dd188be2d6',
        description:
            'A father recounts to his children - through a series of flashbacks - the journey he and his four best friends took leading up to him meeting their mother.',
        title: 'How I Met Your Mother',
        since: '2022-10-18T05:10:00',
        till: '2022-10-18T05:35:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/gvEisYtZ0iBMjnO3zqFU2oM26oM.jpg',
        country: 'Samoa',
        Year: '2005–2014',
        Rated: 'TV-14',
        Released: '19 Sep 2005',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'Carter Bays, Craig Thomas',
        Actors: 'Josh Radnor, Jason Segel, Cobie Smulders',
        Language: 'English, Persian, Chinese',
        Country: 'United States',
        Awards: 'Won 10 Primetime Emmys. 26 wins & 95 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.3',
        imdbVotes: '647,227',
        imdbID: 'tt0460649',
        Type: 'series',
        totalSeasons: '9',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.3/10' }],
        rating: 3,
    },
    {
        id: '74828683-5266-4cfa-b6ce-26ab25512adb',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T05:35:00',
        till: '2022-10-18T06:00:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Guam',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 4,
    },
    {
        id: '02f73d7f-ba0a-4977-8012-5a4218304142',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T06:00:00',
        till: '2022-10-18T07:00:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Unknown or Invalid Region',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 3,
    },
    {
        id: '23f65fc5-7469-4fd2-a0b1-a99dc0699cdb',
        description: 'Comedian Jimmy Fallon hosts a late-night talk show.',
        title: 'Late Night with Jimmy Fallon',
        since: '2022-10-18T07:00:00',
        till: '2022-10-18T07:40:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uu5FuSKleCLh0Kq2pmGzlPH3aeS.jpg',
        country: 'Papua New Guinea',
        Year: '2009–2014',
        Rated: 'TV-14',
        Released: '02 Mar 2009',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Jimmy Fallon, The Roots, Steve Higgins',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 2 Primetime Emmys. 5 wins & 17 nominations total',
        Metascore: 'N/A',
        imdbRating: '6.8',
        imdbVotes: '13,098',
        imdbID: 'tt1231460',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '6.8/10' }],
        rating: 4,
    },
    {
        id: '29226e74-6a2e-4ab3-b665-f142d2eff50d',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T07:40:00',
        till: '2022-10-18T08:05:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Botswana',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 4,
    },
    {
        id: '3eabed85-efaf-4b67-bdc6-dbafcc5b9bed',
        description:
            "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
        title: 'The Book of Boba Fett',
        since: '2022-10-18T08:05:00',
        till: '2022-10-18T08:20:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg',
        country: 'Liberia',
        Year: '2021–',
        Rated: 'TV-14',
        Released: '29 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Action, Adventure, Sci-Fi',
        Director: 'N/A',
        Writer: 'Jon Favreau',
        Actors: 'Temuera Morrison, Ming-Na Wen, Matt Berry',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '20,147',
        imdbID: 'tt13668894',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: '7dfc4fdf-3b73-4bbe-9e18-c5b327230eb9',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T08:20:00',
        till: '2022-10-18T08:45:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Union of Soviet Socialist Republics',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 5,
    },
    {
        id: 'c0651097-4eef-4c13-a57d-90f343cece1e',
        description:
            'Two F.B.I. Agents, Fox Mulder the believer and Dana Scully the skeptic, investigate the strange and unexplained, while hidden forces work to impede their efforts.',
        title: 'The X-Files',
        since: '2022-10-18T08:45:00',
        till: '2022-10-18T09:15:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/bti49Yh5yXrRvsionBGwbh4UKlP.jpg',
        country: 'El Salvador',
        Year: '1993–2018',
        Rated: 'TV-14',
        Released: '10 Sep 1993',
        Runtime: '45 min',
        Genre: 'Crime, Drama, Mystery',
        Director: 'N/A',
        Writer: 'Chris Carter',
        Actors: 'David Duchovny, Gillian Anderson, Mitch Pileggi',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 16 Primetime Emmys. 100 wins & 217 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '213,819',
        imdbID: 'tt0106179',
        Type: 'series',
        totalSeasons: '11',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.6/10' }],
        rating: 2,
    },
    {
        id: '39f2bb84-8cf7-4b63-936b-78fbe50821e5',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T09:15:00',
        till: '2022-10-18T10:20:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'U.S. Minor Outlying Islands',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 5,
    },
    {
        id: '347fe01f-0d96-4870-b116-d4484babe4bf',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T10:20:00',
        till: '2022-10-18T11:15:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Timor-Leste',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 1,
    },
    {
        id: '85bad0e7-36c0-4b06-96b3-51e48014ab7f',
        description:
            'Listen to highlights and extended interviews in the "Ears Edition" of The Daily Show with Trevor Noah. From Comedy Central\'s Podcast Network.',
        title: 'The Daily Show with Trevor Noah: Ears Edition',
        since: '2022-10-18T11:15:00',
        till: '2022-10-18T11:50:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/uyilhJ7MBLjiaQXboaEwe44Z0jA.jpg',
        country: 'Namibia',
        Year: '2018–',
        Rated: 'N/A',
        Released: '20 Feb 2018',
        Runtime: 'N/A',
        Genre: 'Comedy',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Trevor Noah, Ronny Chieng, Michael Kosta',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt13916212',
        Type: 'series',
        totalSeasons: 'N/A',
        Response: 'True',
        Ratings: [],
        rating: 4,
    },
    {
        id: '36db2aaa-207f-4023-bf1c-89f75a8ef44e',
        description:
            "After being struck by lightning, Barry Allen wakes up from his coma to discover he's been given the power of super speed, becoming the Flash, fighting crime in Central City.",
        title: 'The Flash',
        since: '2022-10-18T11:50:00',
        till: '2022-10-18T13:45:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/akuD37ySZGUkXR7LNb1oOHCboy8.jpg',
        country: 'Uruguay',
        Year: '2014–',
        Rated: 'TV-PG',
        Released: '07 Oct 2014',
        Runtime: '43 min',
        Genre: 'Action, Adventure, Drama',
        Director: 'N/A',
        Writer: 'Greg Berlanti, Geoff Johns, Andrew Kreisberg',
        Actors: 'Grant Gustin, Candice Patton, Danielle Panabaker',
        Language: 'English',
        Country: 'United States',
        Awards: 'Nominated for 1 Primetime Emmy. 29 wins & 90 nominations total',
        Metascore: 'N/A',
        imdbRating: '7.6',
        imdbVotes: '331,912',
        imdbID: 'tt3107288',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '7.6/10' }],
        rating: 2,
    },
    {
        id: '73b6dd09-f573-405c-9c59-7610fc5ed53f',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T13:45:00',
        till: '2022-10-18T13:55:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Bangladesh',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 5,
    },
    {
        id: '031c2c6e-22e7-454e-b5df-0d4f13ac527b',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T13:55:00',
        till: '2022-10-18T14:55:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Union of Soviet Socialist Republics',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 3,
    },
    {
        id: '8d4156a6-0593-4162-bd01-4a3d25b9dc1e',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T14:55:00',
        till: '2022-10-18T15:55:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Qatar',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 1,
    },
    {
        id: 'b5678430-c547-461b-aa91-db1863bdaf2f',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T15:55:00',
        till: '2022-10-18T17:00:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Heard Island and McDonald Islands',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 1,
    },
    {
        id: '06105fa2-a886-4a6c-86d8-ef8dd4d9d031',
        description:
            'Shaun Murphy, a young surgeon with autism and Savant syndrome, is recruited into the surgical unit of a prestigious hospital.',
        title: 'The Good Doctor',
        since: '2022-10-18T17:00:00',
        till: '2022-10-18T17:20:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/6Ys6koNajP5ld9EIMfOSQrRquki.jpg',
        country: 'Åland Islands',
        Year: '2017–',
        Rated: 'TV-14',
        Released: '25 Sep 2017',
        Runtime: '41 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'David Shore',
        Actors: 'Freddie Highmore, Hill Harper, Richard Schiff',
        Language: 'English',
        Country: 'United States',
        Awards: '4 wins & 20 nominations',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '84,759',
        imdbID: 'tt6470478',
        Type: 'series',
        totalSeasons: '5',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 1,
    },
    {
        id: '7ee1c765-a44b-4934-8280-c7903b61903a',
        description:
            'Follows the personal and professional lives of six twenty to thirty-something-year-old friends living in Manhattan.',
        title: 'Friends',
        since: '2022-10-18T17:20:00',
        till: '2022-10-18T17:30:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/l0qVZIpXtIo7km9u5Yqh0nKPOr5.jpg',
        country: 'Lithuania',
        Year: '1994–2004',
        Rated: 'TV-PG',
        Released: '22 Sep 1994',
        Runtime: '22 min',
        Genre: 'Comedy, Romance',
        Director: 'N/A',
        Writer: 'David Crane, Marta Kauffman',
        Actors: 'Jennifer Aniston, Courteney Cox, Lisa Kudrow',
        Language: 'English, Spanish, Italian, French, Dutch, Hebrew',
        Country: 'United States',
        Awards: 'Won 6 Primetime Emmys. 77 wins & 220 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '928,567',
        imdbID: 'tt0108778',
        Type: 'series',
        totalSeasons: '10',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 3,
    },
    {
        id: '1769fcf4-0643-4d6b-b021-e3ac3dccb31c',
        description: 'A doctor (Shepard) gets caught up in a war between two aliens (Edwards, Forster).',
        title: 'Peacemaker',
        since: '2022-10-18T17:30:00',
        till: '2022-10-18T18:30:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w500_and_h282_face/ctxm191q5o3axFzQsvNPlbKoSYv.jpg',
        country: 'Isle of Man',
        Year: '1990',
        Rated: 'R',
        Released: '08 Feb 1991',
        Runtime: '100 min',
        Genre: 'Action, Romance, Sci-Fi',
        Director: 'Kevin Tenney',
        Writer: 'Kevin Tenney',
        Actors: 'Robert Forster, Lance Edwards, Hilary Shepard',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.3',
        imdbVotes: '567',
        imdbID: 'tt0100343',
        Type: 'movie',
        DVD: 'N/A',
        BoxOffice: 'N/A',
        Production: 'N/A',
        Website: 'N/A',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.3/10' }],
        rating: 2,
    },
    {
        id: '62c1aa8e-d047-4a6f-a5bf-76357c07f6c6',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T18:30:00',
        till: '2022-10-18T19:25:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Portugal',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 5,
    },
    {
        id: 'be030d07-f5c7-4537-b569-6e81223324f5',
        description:
            'A look at life for a group of high school students as they grapple with issues of drugs, sex, and violence.',
        title: 'Euphoria',
        since: '2022-10-18T19:25:00',
        till: '2022-10-18T19:30:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://images.fanart.tv/fanart/euphoria-2019-5ec8c62aa702d.jpg',
        country: 'Sierra Leone',
        Year: '2019–',
        Rated: 'TV-MA',
        Released: '16 Jun 2019',
        Runtime: '55 min',
        Genre: 'Drama',
        Director: 'N/A',
        Writer: 'Sam Levinson',
        Actors: 'Hunter Schafer, Zendaya, Angus Cloud',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 3 Primetime Emmys. 15 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.4',
        imdbVotes: '101,822',
        imdbID: 'tt8772296',
        Type: 'series',
        totalSeasons: '2',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.4/10' }],
        rating: 4,
    },
    {
        id: '90900c5f-c144-4b16-8c5f-016efee9c6b4',
        description:
            'A comedy revolving around a group of teenage friends, their mishaps, and their coming of age, set in 1970s Wisconsin.',
        title: "That '70s Show",
        since: '2022-10-18T19:30:00',
        till: '2022-10-18T20:05:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/3zRUiH8erHIgNUBTj05JT00HwsS.jpg',
        country: 'Brunei',
        Year: '1998–2006',
        Rated: 'TV-14',
        Released: '23 Aug 1998',
        Runtime: '22 min',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Mark Brazill, Bonnie Turner, Terry Turner',
        Actors: 'Topher Grace, Laura Prepon, Mila Kunis',
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 15 wins & 77 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.0',
        imdbVotes: '163,020',
        imdbID: 'tt0165598',
        Type: 'series',
        totalSeasons: '8',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.0/10' }],
        rating: 5,
    },
    {
        id: '2fdbbd01-be72-4a14-9528-d789c0b1e4e7',
        description: 'The satiric adventures of a working-class family in the misfit city of Springfield.',
        title: 'The Simpsons',
        since: '2022-10-18T20:05:00',
        till: '2022-10-18T20:10:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/hpU2cHC9tk90hswCFEpf5AtbqoL.jpg',
        country: 'Tanzania',
        Year: '1989–',
        Rated: 'TV-PG',
        Released: '17 Dec 1989',
        Runtime: '22 min',
        Genre: 'Animation, Short, Comedy',
        Director: 'N/A',
        Writer: 'James L. Brooks, Matt Groening, Sam Simon',
        Actors: 'Dan Castellaneta, Nancy Cartwright, Harry Shearer',
        Language:
            'English, Spanish, Albanian, French, Japanese, German, Russian, Hindi, Swahili, Italian, Swedish, Turkish, Cantonese, Mandarin, Hebrew, Arabic, Klingon, Bengali, Czech, Chinese',
        Country: 'United States',
        Awards: 'Won 35 Primetime Emmys. 178 wins & 338 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.6',
        imdbVotes: '387,851',
        imdbID: 'tt0096697',
        Type: 'series',
        totalSeasons: '34',
        Response: 'True',
        Ratings: [
            { Source: 'Internet Movie Database', Value: '8.6/10' },
            { Source: 'Rotten Tomatoes', Value: '89%' },
        ],
        rating: 4,
    },
    {
        id: 'a6b76f63-8cde-4e67-83eb-7fe1c2f9cb47',
        description:
            'The series will follow Carrie, Miranda and Charlotte as they navigate the journey from the complicated reality of life and friendship in their 30s to the even more complicated reality of life and friendship in their 50s.',
        title: 'And Just Like That...',
        since: '2022-10-18T20:10:00',
        till: '2022-10-18T20:35:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/1CqkiWeuwlaMswG02q3mBmraiDM.jpg',
        country: 'Iran',
        Year: '2021–',
        Rated: 'TV-MA',
        Released: '09 Dec 2021',
        Runtime: 'N/A',
        Genre: 'Comedy, Drama, Romance',
        Director: 'N/A',
        Writer: 'Michael Patrick King, Darren Star',
        Actors: 'Sarah Jessica Parker, Cynthia Nixon, Kristin Davis',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: '5.4',
        imdbVotes: '18,366',
        imdbID: 'tt13819960',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '5.4/10' }],
        rating: 3,
    },
    {
        id: '6cdd6001-6d18-4e67-b6a6-404e44e08108',
        description:
            'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
        title: 'Peaky Blinders',
        since: '2022-10-18T20:35:00',
        till: '2022-10-18T21:35:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/wiE9doxiLwq3WCGamDIOb2PqBqc.jpg',
        country: 'Anguilla',
        Year: '2013–2022',
        Rated: 'TV-MA',
        Released: '30 Sep 2014',
        Runtime: '60 min',
        Genre: 'Crime, Drama',
        Director: 'N/A',
        Writer: 'Steven Knight',
        Actors: 'Cillian Murphy, Paul Anderson, Helen McCrory',
        Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish',
        Country: 'United Kingdom',
        Awards: 'Won 1 BAFTA Film Award21 wins & 47 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.8',
        imdbVotes: '441,495',
        imdbID: 'tt2442560',
        Type: 'series',
        totalSeasons: '6',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
        rating: 2,
    },
    {
        id: 'd61c1272-298d-4761-ab6f-dbfc2d2cfec6',
        description:
            'Follow Timmy Turner\'s cousin, Vivian "Viv" Turner, and her new stepbrother, Roy Ragland, as they navigate life in Dimmsdale with the help of their fairy godparents, Wanda and Cosmo.',
        title: 'The Fairly OddParents',
        since: '2022-10-18T21:35:00',
        till: '2022-10-18T23:30:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/jlruzecsif3tkCSoHlUaPR01O7U.jpg',
        country: 'Costa Rica',
        Year: '2022–',
        Rated: 'TV-Y7',
        Released: 'N/A',
        Runtime: 'N/A',
        Genre: 'Adventure, Comedy, Family',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: 'Audrey Grace Marshall, Ryan-James Hatanaka, Daran Norris',
        Language: 'English',
        Country: 'United States',
        Awards: 'N/A',
        Metascore: 'N/A',
        imdbRating: 'N/A',
        imdbVotes: 'N/A',
        imdbID: 'tt15057532',
        Type: 'series',
        totalSeasons: '1',
        Response: 'True',
        Ratings: [],
        rating: 5,
    },
    {
        id: '9df705ca-8607-429b-afd7-e8ff8f6085b4',
        description:
            "Conan O'Brien, a Harvard Lampoon alumnus, hosts this late-night comedy/talk-show, which is often silly and whimsical.",
        title: "Late Night with Conan O'Brien",
        since: '2022-10-18T23:30:00',
        isTomorrow: true,
        till: '2022-10-19T01:25:00',
        channelUuid: 'faf1be3a-ec39-43ab-86c4-37f3e59c2a7a',
        image: 'https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/q9unI9oHyLUNK97RQPYAGjFs4Xu.jpg',
        country: 'Tuvalu',
        Year: '1993–2009',
        Rated: 'TV-14',
        Released: '13 Sep 1993',
        Runtime: '60 min',
        Genre: 'Comedy, Music, Talk-Show',
        Director: 'N/A',
        Writer: 'N/A',
        Actors: "Conan O'Brien, The Max Weinberg 7, Andy Richter",
        Language: 'English',
        Country: 'United States',
        Awards: 'Won 1 Primetime Emmy. 8 wins & 55 nominations total',
        Metascore: 'N/A',
        imdbRating: '8.1',
        imdbVotes: '17,900',
        imdbID: 'tt0106052',
        Type: 'series',
        totalSeasons: '17',
        Response: 'True',
        Ratings: [{ Source: 'Internet Movie Database', Value: '8.1/10' }],
        rating: 4,
    },
];
